import React, { Component } from 'react';
import _, { filter } from 'lodash';
import cx from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Grid,
	Checkbox,
	Chip,
	Modal,
	CardHeader,
	IconButton,
	Collapse,
	Card,
	Typography,
	CardContent,
	Button,
	Popover,
	MenuList,
	MenuItem,
	ListItemIcon,
	FormGroup,
	FormControlLabel,
	Paper,
	Tooltip,
} from '@material-ui/core';


//components
import ContentMenu, { SHAREDWITHMEKAY } from '../components/ContentMenu';
import GoalsDriller from '../components/GoalsDriller';
import ContentFilter from '../components/ContentFilter';
import ContentSearch from '../components/ContentSearch';
import ContentPagination from '../components/ContentPagination';
import ContentCard from '../components/ContentCard';
import ContentDetailsDrawer from '../components/ContentDetailsDrawer';
import ContentDeleteConfirm from '../components/ContentDeleteConfirm';
import ContentShareModal from '../components/ContentShareModal';

//types
import GoalDrillerData from '../types/GoalDrillerData';
import ContentFilterData, { ContentListFilterData } from '../types/ContentFilterData';
import ContentData from '../types/ContentData';
//actions
import contentActions from '../actions/contentActions';


import contentService from '../services/contentService';
import CloseIcon from '@material-ui/icons/Close';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

// from testpaper
import contentStatusActions from '../actions/contentStatusActions';
import contentTypeActions from '../actions/contentTypeActions';
import contentSubtypeActions from '../actions/contentSubtypeActions';
import contentTagsActions from '../actions/contentTagsActions';
import coursesActions from '../actions/coursesActions';
import { classesList } from '../actions/classesActions';
import { ContentTypeData } from '../../tag-mangement/types/ContentTypeData';
import ContentSubtypeData from '../types/ContentSubtypeData';
import ContentStatusData from '../types/ContentStatusData';
import FilterByData from '../types/FilterByData';
import PerfectScrollbar from 'react-perfect-scrollbar';
import CustomInfoIcon from '../../common/CustomInfoIcon';
import ACLService from '../../acl/services/aclService';
import { contentList } from '../__mocks__/contentList';
import NoFilteredContent from './NoFilteredContent';
import { toggleLicenseExpiredDialog } from "../../login/actions/userActions";
import DialogLarge from '../../content-request/common/DialogLarge';
import { MyPATDialog } from '../../common';
import { CONTENT_SECTION_KEYS, CONTENT_SECTION_TYPES, MODULE_TO_QUESTION_PERMISSION_MAP, MODULE_TO_TEST_PERMISSION_MAP, STATUS_CODES, USER_RIGHTS, contentTypesForContentHistoryMap, USER_TYPE, PERMISSION_CONTENT_TYPES, ACADEMIC_YEAR_START, MARCH_MONTH_INDEX, AUTHORING_QUESTION_CONTENT_TYPES, AUTHORING_TEST_CONTENT_TYPES, AUTHORING_CONTENT_TYPES, CONTENT_TYPE_FILTERS, FILTER_CATEGORIES, PREVIOUS_CONTENT_START_YEAR, CONTENT_TYPES_TO_HIDE_FROM_FILTER, CONTENT_STATES } from '../../../constants/comman';
import { ACADEMIC_STAT, API_ERROR_CODES, CARD_STATUS, CLEAR_ALL_TAGS_TOASTER_MSG, DEFAULT_ERROR_MSG, STAT_TYPE, STAT_TYPE as statYear, VALIDATION, VALIDATION_ACADEMIC, VALIDATION_DIALOG_DATA, VALIDATION_DIALOG_INFO_TYPES } from '../constant/content';
import { checkForTeacherUser, createDeepCopy, getPropertyValue, getUserType } from '../../../utils';
import contentRequestServices from '../../content-request/services/contentRequestServices';
import { showMsg } from '../../course/actions/loaderAlert';
import { VARIANT } from '../../common/types/ServerAlertDataV2';
import { MyPATDropdown } from '../../common';
import { FEEDBACK_VALIDATOR_ACTIONS } from '../helper/contentValidation';
import PublishContentDirecltyModal from '../components/PublishContentDirecltyModal';
import CustomFilter from './CustomFilter';
import DialogFooter from '../../content-request/common/DialogFooter';


const styles = (theme: Theme) => createStyles({
	highlightedContent: {
		backgroundColor: '#FFF3F3',
		borderRadius: '8px',
		padding: '13px 15px',
		display: 'flex',
		margin: '10px 0',
		width: '100%',
		'& img': {
			width: '22px',
			marginRight: '12px',
		},
		'& p': {
			fontSize: '14px',
			fontWeight: 500,
			lineHeight: '128%',
			marginBottom: '0px',
			marginTop: '0px',
			color: '#666666',
		}
	},
	borderBlue: {
		color: '#1D7DEA !important',
		border: '1px solid #1D7DEA',
		fontSize: '0.875rem'
	},
	dataManipulateIcons: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		gap: '10px',
		'& .publishDirectly': {
			width:36,
			height:36,
			boxShadow: "0px 0px 4px 0px #00000040",
			borderRadius:50,
			display: "flex",
			justifyContent: "center",
			alignItems: "center",
			cursor: 'pointer',
		},
		'& img': {
			cursor: 'pointer'
		}
	},
	noSelectedText: {
		'&>:nth-child(1)': {
			paddingLeft: 17,
			color: 'rgb(51 51 51)'
		}
	},
	paper: {
		margin: '0 0 18px 0'
	},
	SelectCheckedCheckbox: {
		backgroundColor: '#1d7dea!important',
		border: '1px solid #1d7dea !important',
		borderRadius: 2,
		color: '#99a1a7',
		'&::before': {
			content: "''",
			fontSize: 14,
			position: 'absolute',
			top: '-1px',
			left: 4,
			width: 4,
			height: 10,
			border: 'solid #fff',
			borderWidth: '0 2px 2px 0',
			transform: 'rotate(45deg)'
		},
		'&:hover': {
			backgroundColor: '#1d7dea'
		}
	},
	checkedCheckbox: {
		backgroundColor: '#1d7dea!important',
		border: '1px solid #1d7dea !important',
		borderRadius: 2,
		color: '#99a1a7',
		'&::before': {
			content: "''",
			fontSize: 14,
			position: 'absolute',
			top: 1,
			left: 6,
			width: 4,
			height: 10,
			border: 'solid #fff',
			borderWidth: '0 2px 2px 0',
			transform: 'rotate(45deg)'
		},
		'&:hover': {
			backgroundColor: '#1d7dea'
		}
	},
	SelectcheckedCheckbox: {
		backgroundColor: '#1d7dea!important',
		border: '1px solid #1d7dea !important',
		borderRadius: 2,
		color: '#99a1a7',
		width: '16px',
		height: '16px',
		padding: 0,
		'&::before': {
			content: "''",
			fontSize: 14,
			position: 'absolute',
			top: 0,
			left: 4,
			width: 4,
			height: 10,
			border: 'solid #fff',
			borderWidth: '0 2px 2px 0',
			transform: 'rotate(45deg)'
		},
		'&:hover': {
			backgroundColor: '#1d7dea'
		}
	},
	SelectCheckbox: {
		padding: 0,
		top: 0,
		left: 6,
		width: 16,
		height: 16,
		'-moz-appearance': 'none',
		opacity: 1,
		color: 'rgb(204, 204, 204)',
		border: '1px solid #1D7DEA',
		borderRadius: 2,
		'& svg': {
			fontSize: '1.5rem',
			fontFamily: '"Nunito", sans-serif',
			fill: '#979797',
			opacity: 0
		}
	},
	checkBoxElement: {
		padding: '0px 7px',
		top: 0,
		width: 20,
		height: 20,
		'-moz-appearance': 'none',
		opacity: 1,
		color: 'rgb(204, 204, 204)',
		border: '1px solid #B2B2B2',
		borderRadius: 4,
		margin: '-4px 14px 0px 16px',
		'& svg': {
			fontSize: '1.5rem',
			fontFamily: '"Nunito", sans-serif',
			fill: '#979797',
			opacity: 0
		}
	},

	checkboxLabel: {
		fontSize: 18,
		color: '#363636',
	},
	formControlLabel: {
		marginBottom: 6
	},
	lightGrey: {
		color: 'rgb(102 102 102)'
	},
	listItemIcon: {
		marginRight: -4,
		'& :first-child': {
			top: 0,
			height: 14,
			width: 14,
			left: 2
		},
		'&>:first-child::after': {
			top: -1,
			left: 4
		}
	},
	paddingZero: {
		paddingTop: 0,
		paddingBottom: 0
	},
	popoverRoot: {
		marginLeft: -20
	},
	contentFilter: {
		paddingTop: theme.spacing.unit * 2,
	},
	checkbox: {
		padding: 0,
		top: 0,
		left: 6,
		width: 16,
		height: 16,
		'-moz-appearance': 'none',
		opacity: 1,
		color: 'rgb(204, 204, 204)',
		border: '1px solid #1D7DEA',
		borderRadius: 2,
		marginRight: 14,
		'& svg': {
			fontSize: '1.5rem',
			fontFamily: '"Nunito", sans-serif',
			fill: '#979797',
			opacity: 0
		}
	},
	primaryColor: {
		color: 'rgb(29 125 234)'
	},
	height1X: {
		height: 76
	},
	paddingLeft: {
		paddingLeft: 11
	},
	paddingRight: {
		paddingRight: 11
	},
	cursorPointer: {
		cursor: 'pointer',
		'& :hover': {
			color: '#417dea'
		}
	},
	paddingSm: {
		padding: '10px 20px'
	},
	textRight: {
		textAlign: 'right',
	},
	greyColor: {
		fontStyle: 'normal',
		fontWeight: 600,
		fontSize: 16,
		lineHeight: '24px',
		display: 'flex',
		alignItems: 'center',
		color: '#333333'
	},
	inlineBlock: {
		display: 'inline-block'
	},
	filterChip: {
		verticalAlign: 'super',
		margin: '4px 4px',
		backgroundColor: 'rgb(244 244 244)',
		border: '1px solid rgb(235, 235, 235)',
		'& svg': {
			color: 'rgb(153, 153, 153)'
		}
	},
	filterListBlock: {
		'& .ps--active-x > .ps__rail-x, .ps--active-y > .ps__rail-y': {
			opacity: 12,
			width: 10,
			backgroundColor: '#eee'
		},
		'& .ps__thumb-y, .ps__rail-y:hover > .ps__thumb-y': {
			backgroundColor: '#999',
			width: 6
		}
	},
	relativeBox: {
		position: 'relative',
	},
	leftSideBar: {
		'&>:first-child': {
			// marginTop: 84
		}
	},
	tableView: {
		display: 'table'
	},
	marginMDBgWhite: {
		marginTop: 0,
		background:'#fff',
	},
	fixedSection: {
		background: '#fff',
		position: 'sticky',
		top: 'calc(64px + 129px)',
		alignContent: 'space-between',
		alignItems: 'flex-start',
		display: 'flex',
		flexWrap: 'wrap',
		justifyContent: 'flex-start',
		zIndex: 10,
		width: '100%',
		border: '1px solid #c6c6c6',
		boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2)',
		height: 'auto',
		padding: '6px',

	},
	fixedSectionScroll: {
		background: 'rgb(255 255 255)',
		boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
		boxSizing: 'border-box',
		borderRadius: 8,
		top: 'calc(64px + 261px)',
		alignContent: 'space-between',
		alignItems: 'flex-end',
		display: 'flex',
		flexWrap: 'wrap',
		zIndex: 10,
		width: '100%',
		minHeight: 50,
		padding: '0px 8px',
		marginTop: '24px'
	},
	searchBox: {
		display: 'flex',
		alignItems: 'center',
		gap: '16px'
	},
	cardHeader: {
		fontSize: '1rem',
		fontFamily: '"Nunito", sans-serif',
		color: 'rgba(50, 60, 71, 1)',
		width: '100%',
		padding: '0px 8px',
		'& h6': {
			fontWeight: 600,
			fontSize: 16,
			lineHeight: '22px',
			color: '#333333'
		}
	},
	fromTestPaper: {
		top: '0',
		position: 'relative'
	},
	borderBottom: {
		borderBottom: 'solid 1px #e6e6e6'
	},
	modal: {
		display: 'flex',
		padding: 12,
		alignItems: 'center',
		justifyContent: 'center',
	},
	modalHeader: {
		minHeight: 46,
		padding: '4px 20px 0px',
		'& span': {
			fontFamily: '"Nunito", sans-serif',
			fontStyle: 'normal',
			fontWeight: 600,
			fontSize: '28px',
			lineHeight: '32px',
			textAlign: 'center',
			color: '#333333'
		},
		'& .modalHeading': {
			color: '#333333',
			fontSize: '18px',
            fontWeight: 800,
            lineHeight: '1.2',
            padding: '16px',
		},
	},
	scrollBarX: {
		display: 'flex',
		padding: 8,
		alignItems: 'center',
		paddingBottom: '0px !important',
		'& .scrollbar-container': {
			width: 295,
			overflowX: 'auto',
			paddingBottom: 20,
			padding: 0,
			"@media (max-width: 1600px)": {
				width: 360,
			},

			"@media (max-width: 1400px)": {
				width: 320,
			},

			"@media (max-width: 1366px)": {
				width: 310,
			},
			"@media (max-width: 1280px)": {
				width: 280,
			},
		}
	},
	categoryCardContent: {
		minHeight: '65vh',
		height: 100
	},
	categoryCardAction: {
		justifyContent: 'flex-end',
		padding: 4
	},
	filterCard: {
		width: 900,
		backgroundColor: '#E6E6E6',
		boxShadow: theme.shadows[5],
		padding: '20, 40, 30',
		textAlign: 'center',
		borderRadius: 4,
		outline: 'none !important',
		'& :focus': {
			outline: 'none'
		}
	},
	clearTagsModal: {
		width: 510,
		padding: '30px 40px',
		backgroundColor: '#ffffff',
		'& .modal-header': {
			fontSize: '18px',
			fontWeight: 700,
			lineHeight: '20px',
			textAlign: 'center',
			marginBottom: '40px',
		},
		'& .modal-content': {
			padding: '0 0 40px',
		},
		'& .modal-para': {
			fontSize: '18px',
			fontWeight: 400,
			lineHeight: '25.2px',
			textAlign: 'center'
		},
		'& .modal-footer': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			gap: '18px',
		},
		'& .btn-border': {
			border: '1px solid #1D7DEA',
			backgroundColor: 'transparent',
			borderRadius: '4px',
			minWidth: '140px',
			height: '36px',
			fontSize: '14px',
			fontWeight: 500,
			color: '#1D7DEA',
			padding: '5px 10px',
		},
		'& .btn-primary': {
			border: '1px solid #1D7DEA',
			backgroundColor: '#1D7DEA',
			borderRadius: '4px',
			minWidth: '140px',
			height: '36px',
			fontSize: '14px',
			fontWeight: 500,
			color: '#ffffff',
			padding: '5px 10px',
		},
	},
	root: {
		justifyContent: 'center',
		display: 'block',
		'& .modalContent': {
			color: '#666666',
			fontSize: '18px',
			lineHeight: '1.4',
			textAlign: 'center',
		},
		'&. btnTransparent': {
			border: '1px solid #1D7DEA',
			borderRadius: '4px',
            padding: '8px 20px',
            color: '#1D7DEA',
            cursor: 'pointer',
            transition: 'all 0.3s',
			fontSize: '14px',
			lineHeight: '1.4',
		},
		'& .btnPrimary': {
			backgroundColor: '#1D7DEA',
            border: 'none',
            borderRadius: '4px',
            padding: '8px 20px',
            color: '#FFFFFF',
            cursor: 'pointer',
            transition: 'all 0.3s',
			fontSize: '14px',
			lineHeight: '1.4',
			marginLeft: '20px',
		}
	},
	addFilterWrapper: {
		display: 'flex',
		justifyContent: 'center',
		padding: 10,
		marginTop: 24
	},
	modalFilterChip: {
		overflow: 'auto',
		justifyContent: 'flex-start',
		fontSize: 16,
		lineHeight: '24px',
		display: 'flex',
		alignItems: 'center',
		color: '#666666',
		fontStyle: 'normal',
		fontWeight: 'normal',
		height: 50,
		fontFamily: "'Nunito/', sans-serif"
	},
	filterList: {
		height: '63vh',
	},

	expand: {
		transform: 'rotate(0deg)',
		marginLeft: 'auto',
		transition: theme.transitions.create('transform', {
			duration: theme.transitions.duration.shortest,
		}),
		right: -6
	},
	expandOpen: {
		transform: 'rotate(180deg)',
	},
	marginTop1x: {
		marginTop: 12
	},
	marginTop2x: {
		marginTop: 20
	},
	filterLabel: {
		minWidth: 132,
		padding: '-8px 0px',
		float: 'left'
	},
	marginXL: {
		margin: '40px 0px'
	},
	infoIcon: {
		position: 'relative',
		top: -2,
		'& second-child': {
			marginLeft: -105,
			top: 25
		}
	},
	tuneIcon: {
		'&:hover:after': {
			content: '""',
			position: 'absolute',
			left: '50%',
			marginLeft: -5,
			bottom: -7,
			width: 0,
			height: 0,
			borderLeft: '5px solid rgba(0, 0, 0, 0)',
			borderRight: '5px solid rgba(0, 0, 0, 0)',
			borderBottom: '8px solid rgb(0, 0, 0)'
		}
	},
	toolTipArrow: {
		'&:hover:after': {
			content: '""',
			position: 'absolute',
			left: '50%',
			marginLeft: -5,
			bottom: -8,
			width: 0,
			height: 0,
			borderLeft: '5px solid rgba(0, 0, 0, 0)',
			borderRight: '5px solid rgba(0, 0, 0, 0)',
			borderBottom: '8px solid rgb(0, 0, 0)'
		}
	},
	tooltipDetails: {
		position: 'absolute',
		marginTop: 40,
		zIndex: 999999
	},
	disable: {
		opacity: 0.5,
		pointerEvents: "none"
	},
	filterPaper: {
		boxShadow: 'none',
		maxHeight: '100px',
		width: '100% !important',
		paddingBottom: '0 !important',
		'& label': {
			display: 'flex',
		},
		'& .ps__rail-y': {
			opacity: 1,
		}
	},
	fullWidth: {
		width: '100%',
		overflowX: 'hidden',
	},
	legendText: {
		fontSize: '14px',
		fontWeight: 400,
		color: '#1D7DEA',
		padding: '2px 15px 2px 0px',
		position: 'relative',
		cursor: 'pointer',
		'&::after': {
			content: "''",
			position: 'absolute',
			right: 0,
			top: 0,
			width: '1px',
			height: '100%',
			backgroundColor: '#E6E6E6',
		}
	},
	legendModalTitle: {
		padding: '9px 0 6px',
		textAlign: 'center',
		fontSize: '24px',
		fontWeight: 600,
		color: '#333333',
		lineHeight: '133%',
		display: 'block',
	},
	legendListing: {
		margin: '0',
		maxHeight: '390px',
		overflowY: 'auto',
		padding: '30px',
		'&::-webkit-scrollbar': {
			width: '5px',
		},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: 'darkgrey',
			borderRadius: '20px',
		},
		'& .listItem': {
			display: 'flex',
			border: '1px solid #E6E6E6',
			marginBottom: '10px',
			'& .col-left': {
				width: '21%',
				padding: '10px 15px',
				position: 'relative',
				display: "flex",
				alignItems: "center",
				'& p': {
					fontSize: '14px',
					fontWeight: 500,
					lineHeight: '114%',
					margin: 0,
					transition: 'none',
				},
				'&.dueText': {
					color: '#EC1C24',
				},
				'&.reSubmittedText': {
					color: '#F2982E',
				},
				'&.approvedText': {
					color: '#30BE76',
				},
				'&.rejectedText': {
					color: '#EC1C24',
				},
				'&.penaltyText': {
					color: '#EC1C24',
				},
				'&.vivid-blue': {
					color: "#1D7DEA",
				},
				'&.dark-gray': {
					color: "#333333",
				},
				'&.light-peach': {
					backgroundColor: '#FFF5E8',
				},
				'&.light-ivory': {
					backgroundColor: '#FFF9E5',
				},
				'&.mint-green': {
					backgroundColor: "#E5FCE3",
				},
				'&.blush-pink': {
					backgroundColor: "#FFF1F1",
				},
				'&.lavender': {
					backgroundColor: "#F8F1FF",
				},
				'&.baby-blue': {
					backgroundColor: "#F1FCFF",
				},
				'&::after': {
					content: "''",
					position: 'absolute',
					right: '0',
					top: '50%',
					transform: 'translateY(-50%)',
					backgroundColor: '#E6E6E6',
					width: '1px',
					height: '35px',
				}
			},
			'& .separator': {
				height: '100%',
				width: 1,
				backgroundColor: '#E6E6E6',
			},
			'& .col-right': {
				width: '79%',
				padding: '10px 15px',
				'& p': {
					fontSize: '14px',
					fontWeight: 500,
					lineHeight: '128%',
					color: '#666666',
					margin: 0,
					whiteSpace: 'pre-line',
				}
			},
			'&.other-info': {
				'& .col-left': {
					color: '#333',
				},
				'& .col-left:after': {
					display: 'none'
				},
				'& .col-right': {
					borderLeft: 'solid 1px #e6e6e6',
				}
			}
		}
	},
	filterHeaderClassName:{
		position:'sticky',
		top:'0',
		left:'100px',
		'z-index':'999',
		background:'#FBFBFB',
		width:'100%',

	},
	browseByTopics:{
		position:'fixed',
		right:'-400px',
		top:0,
		width:400,
		background:'#fff',
		borderRadius:8,
		'z-index':'99999',
		height:'100%',
		transition: 'all .5s',
		
	},	
	visiblebrowseTopic: {
		right: '0',
		transition: 'all .5s',
		'&::before':{
			content:'',
			position:'fixed',
			left:'0',
			top:'0',
			width:'100vw',
			height:'100vh',
			background:'#333333',
			'z-index':'99998',
		},
	},
	"@keyframes slideOutBrowse": {
		from: {
		  right: "-400px",
		},
  
		to: {
		  right: '0',
		},
	  },
	selectAllText: {
		minWidth: 'fit-content',
	},
	
	fixTopSearch: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		width: 'calc(100% + 30px)',
		position: 'sticky',
		top: 130,
		background: '#fff',
		padding: '10px 0px 10px 5px',
		zIndex: 9,
		marginLeft: '-11px',
		'& > div > div':{
			marginBottom: 0,
		},
		heightSet:{
			height:36,
		},
	},
	legendDialogAction: {
		'& button': {
			height: 44,
			width: 100,
		}
	},
	validationInfoTabs: {
		display: 'flex',
		justifyContent: 'center',
		alignItems: 'center',
		'& ul': {
			borderRadius: 4,
			display: 'flex',
			padding: '0',
			marginTop: '20px',
			'& li': {
				width: 167,
				height: 36,
				padding: '7px 15px',
				color: '#666',
				fontSize: 16,
				fontWeight: 400,
				listStyle: 'none',
				textAlign: 'center',
				border: '1px solid #E6E6E6',
				borderWidth: '1px 0px',
				cursor: 'pointer',
			},
			'& li:first-child': {
				borderLeftWidth: '1px',
				borderRadius: '4px 0px 0px 4px'
			},
			'& li:last-child': {
				borderRightWidth: '1px',
				borderRadius: '0px 4px 4px 0px'

			},
			'& li.active': {
				background: '#1D7DEA',
				borderColor: '#1D7DEA',
				color: '#FFF',
			}
		}
	},
	globalSearchTabsSection: {
		backgroundColor: 'rgba(244, 244, 244, 0.5)',
		borderRadius: '4px',
		padding: '10px 20px',
		gap: '10px 20px',
		display: 'flex',
		width: '100%',
		marginBottom: '10px',
		'& .search-for-text': {
			fontSize: '12px',
			fontWeight: 400,
			lineHeight: '167%',
			color: '#999999',
			whiteSpace: 'nowrap',
		},
		'& .tab-listing': {
			display: 'inline-flex',
			alignItems: 'center',
			flexWrap: 'wrap',
			gap: '5px',
			padding: '0',
			margin: '0',
			height: '27px',
			overflowY: 'hidden',
			overflowX: 'hidden',
			'& li': {
				border: '1px solid #E6E6E6',
				borderRadius: '20px',
				padding: '4px 8px',
				maxWidth: '170px',
				display: 'inline-flex',
				alignItems: 'center',
				gap: '5px',
				cursor: 'pointer',
				position: 'relative',
				height: '27px',
				'& button': {
					padding: '0',
					height: '100%',
					minWidth: '100%',
					fontSize: 'inherit',
					lineHeight: 'normal',
					borderRadius: '0',
				},
				'& button:hover': {
					backgroundColor: 'transparent',
				},
				'& h6': {
					fontSize: '12px',
					fontWeight: 500,
					lineHeight: '136%',
					color: '#666666',
					margin: '0',
				},
				'& h6.hiddenContent': {
					width: 'calc(100% - 17px)',
					whiteSpace: 'nowrap',
					textOverflow: 'ellipsis',
					overflow: 'hidden',
				},
				'& em': {
					fontStyle: 'normal',
					width: '12px',
					height: '12px',
					backgroundImage: 'url(/assets/svg/globalSearch/cross-icon.svg)',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'cover',
					cursor: 'pointer',
					transition: 'all 0.3s',
				},
				'& em:hover': {
					backgroundImage: 'url(/assets/svg/globalSearch/cross-icon-hover.svg)',
				},
				'&:hover span': {
					color: '#1D7DEA',
				},
			}
		},
		'& .clear-text': {
			display: 'inline-flex',
			alignItems: 'center',
			gap: '10px',
			marginLeft: 'auto',
			whiteSpace: 'nowrap',
			alignSelf: 'flex-start',
			'& .heading': {
				fontSize: '12px',
				fontWeight: 400,
				lineHeight: '167%',
				color: '#1D7DEA',
				borderRight: '1px solid #E6E6E6',
				paddingRight: '10px',
				margin: '0',
				cursor: 'pointer',
			},
			'& .arrow': {
				width: '24px',
				minWidth: '24px',
				height: '24px',
				borderRadius: '50%',
				backgroundColor: 'rgba(29, 125, 234, 0.1)',
				display: 'inline-flex',
				alignItems: 'center',
				justifyContent: 'center',
				position: 'relative',
				'&::after': {
					content: "''",
					position: 'absolute',
					top: '50%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					width: '10px',
					height: '10px',
					backgroundImage: 'url(/assets/svg/globalSearch/arrow.svg)',
					backgroundPosition: 'center',
					backgroundRepeat: 'no-repeat',
					backgroundSize: 'contain',
					transition: 'all 0.3s',
				}
			}
		},
		'&.see-all': {
			flexWrap: 'wrap',
			'& .tab-listing': {
				height: '100%',
				width: 'calc(100% - 100px)',
				order: 3,
				overflowX: 'hidden',
			},
			'& .clear-text .arrow::after': {
				transform: 'translate(-50%, -50%) rotate(180deg)',
			}
		}
	},
	customTooltip: {
		backgroundColor: '#666666',
		fontSize: '12px',
		fontWeight: 500,
		fontFamily: 'Nunito',
		lineHeight: '15.6px',
		maxWidth: '70%',
		'&::after': {
			content: "''",
			position: 'absolute',
			top: '-7px',
			left: '50%',
			transform: 'translateX(-50%)',
			borderLeft: '8px solid transparent',
			borderRight: '8px solid transparent',
			borderBottom: '12px solid #666666',
		}
	},
	'cardsContainer': {
		maxHeight: 'calc(100vh - 219px)',
		overflowY: 'auto' 
	}
});

//@ts-ignore
interface WithContentProps extends WithStyles<typeof styles> {
	classes: any,
	contentList: ContentData[],
	contentActionList: Function,
	clearContentListData: Function,
	userId: string,
	isInPopUp: boolean,
	isCreatedByMe: boolean,
	type: string,
	onContentSelect: Function,
	onContentSelectAll: Function,
	onCheckContentExist?: (content_id: any) => boolean,
	selectedQuestions: ContentData[],
	selectedTrackedQuestionIds: any,
	selectedFilterContent: ContentListFilterData,
	filterHeaderClassName: any,
	fromCourse: any,
	fromTestPaper: boolean,
	selectedContentCourse: any,
	goals: any,
	contentMenuRequired: boolean,
	filterSelectedQuestion: any,
	handleSelectAll: Function,
	fromMiniLibrary: Boolean,
	contentFilterData: ContentFilterData[],
	removeDisabilityFromCheckBox: boolean,
	fromCourseMangement?: boolean;
	// from testpaper
	contentType: {
		list: ContentTypeData[]
	},
	contentSubtype: {
		list: ContentSubtypeData[],
		question: ContentSubtypeData[],
		testpapers: ContentSubtypeData[],
		studymaterial: ContentSubtypeData[],
	},
	contentStatus: {
		list: ContentStatusData[]
	},
	contentTags: {
		list: any[]
	},
	courses: {
		list: any[]
	},
	filterBy: {
		list: FilterByData[],
	},
	classesData: {
		list: any[]
	},
	contentStatusList: Function,
	contentTypeList: Function,
	contentSubtypeList: Function,
	contentTagsList: Function,
	coursesList: Function,
	userFilterList: Function,
	contentSubtypeByContentTypeCode: Function,
	contentFilterDataChanged: Function,
	classesList: Function,
	userData: any,
	isSelectAllRequired: Boolean,
	contentCreateOption: Boolean;
	loggedInUserData: any,
	showLicenseExpiredDialog: any,
	isPostExpiryDays: any,
	toggleLicenseExpiredDialog: any,
	alwaysFetchCoursesInGoalDriller?: boolean;
	isConcept?: boolean;
	isCourse?: boolean;
	getAllSelectCount?: Function;
	selectedContentType?: string;
	updateContentType: Function;
	isChapter?: boolean;
	fromTestCreate?: boolean;
	fromNotes?: boolean;
	bucketsToDisplay?:any[];
	preSelectedBucket?: string;
	contentStatusCode?: number;
	showMsg: Function;
	contentValidationStatusList: Function;
	isQuestionSubtypeLoaded?: boolean;
	isStudyMaterialSubtypeLoaded?: boolean;
}


interface WithContentStates {
	isAddFilterOpen: boolean,
	isDetailDrawerOpen: boolean,
	DetailDrawerContent?: ContentData,
	filterContent: ContentListFilterData,
	currentPage: number,
	limit: number,
	totalCount: number,
	selectedContents: ContentData[],
	filteredQuestions: ContentData[],
	unselectedContents: any[],
	selectedContentsAll: boolean,
	dropdownSelectedValue: boolean,
	isDeleteDialogOpen: boolean,
	isShareDialogOpen: boolean,
	topSpacing: number,
	isAllPages: boolean,
	areGoalsSectionClicked: boolean,
	contentFilterData: ContentFilterData[],
	expandedFilter: boolean,
	visibleFilters: any,
	showTooltipExpand: boolean,
	anchorEl: any,
	setAnchorEl: any,
	isAllItemSelected: boolean,
	selectAllContent: boolean,
	isRevert: boolean,
	isApply: boolean,
	selectedContentType: any;
	selectedBucketType: string;
	bucketsToShow: any[];
	isTotalCountLoading: boolean,
	academicYear: any,
	academicYearList: any[],
	selectedAcademicYearList: number[],
	legendDialogVisible: boolean,
	validationDialogInfoType: string;
	isPublishDirectlyModalOpen: boolean,
	isSideFilterOpen: boolean,
	isGoalsDrillerOpen: boolean,
	isFilterBuilt: boolean,
	bucketWiseCount: any,
	recentSuggestions: any[];
	tagsPool: any[];
	searchResults: any[];
	recentTagsCount: number;
	tempSearchText: string;
	clearTagModal: boolean;
	recentSelectedTag: any;
	seeAllTags: boolean;
	isSearchBoxClicked: boolean;
	isWidthReached: boolean;
}

class WithContent extends Component<WithContentProps, WithContentStates>{
	searchInterval: any;
	private ulRef: any;
	public static defaultProps = {
		contentMenuRequired: true,
		removeDisabilityFromCheckBox: false,
		type: ''
	};
	filters: any = {
		contentType: {
			visible: !getUserType(USER_TYPE.STUDENT),
			subFilters: {
				question: true,
				studymaterial: true,
				testpapers: true
			}
		},
		status: {
			visible: true,
			subFilters: {
				PUBLISHED: true,
				DRAFT: true,
				REVIEW: true
			}
		}
	}
	public isUserTeacher: boolean = false;
	constructor(props: WithContentProps) {
		super(props);
		this.ulRef = null;
		const tabsToShow = this.props.bucketsToDisplay || CONTENT_SECTION_TYPES.filter(tab => {
			return [USER_RIGHTS.VIEW, USER_RIGHTS.CREATE, USER_RIGHTS.EDIT].some(right => {
				if(tab.value === CONTENT_SECTION_KEYS.GLORIFIRE) {
					const hasAccessToStudyMaterial = [USER_RIGHTS.VIEW, USER_RIGHTS.CREATE, USER_RIGHTS.EDIT].some(right => ACLService.checkModulePermission(PERMISSION_CONTENT_TYPES.STUDY_MATERIAL, right));
					if(hasAccessToStudyMaterial) return true;
				}
				return (ACLService.checkModulePermission(MODULE_TO_QUESTION_PERMISSION_MAP[tab.value], right) || ACLService.checkModulePermission(MODULE_TO_TEST_PERMISSION_MAP[tab.value], right));
			});
		});
		this.state = {
			// isShowShareDelete: false,
			isAddFilterOpen: false,
			isDetailDrawerOpen: false,
			filterContent: {
				bucketType: this.props.preSelectedBucket || (tabsToShow.length ? tabsToShow[0].value : ''),
				contentMenu: "all",
				...this.props.selectedFilterContent
			},
			currentPage: 1,
			limit: 20,
			totalCount: 0,
			selectedContents: [],
			unselectedContents: [],
			selectedContentsAll: false,
			dropdownSelectedValue: false,
			filteredQuestions: [],
			isDeleteDialogOpen: false,
			isShareDialogOpen: false,
			topSpacing: 0,
			isAllPages: false,
			areGoalsSectionClicked: true,
			contentFilterData: props.contentFilterData,
			expandedFilter: true,
			visibleFilters: ['contentType', 'status', 'courses'],
			showTooltipExpand: false,
			anchorEl: null,
			setAnchorEl: null,
			isAllItemSelected: false,
			selectAllContent: false,
			isRevert: false,
			isApply: false,
			selectedContentType: '',
			selectedBucketType: this.props.preSelectedBucket || (tabsToShow.length ? tabsToShow[0].value : ''),
			bucketsToShow: tabsToShow,
			isTotalCountLoading: false,
			academicYear: {},
			academicYearList: [],
			selectedAcademicYearList: [],
			legendDialogVisible: false,
			validationDialogInfoType: '', 
			isPublishDirectlyModalOpen: false,
			isSideFilterOpen: false,
			isGoalsDrillerOpen: false,
			isFilterBuilt: false,
			bucketWiseCount: {},
			recentSuggestions: [],
			tagsPool: [],
			searchResults: [],
			recentTagsCount: 0,
			tempSearchText: '',
			clearTagModal: false,
			recentSelectedTag: '',
			seeAllTags: false,
			isSearchBoxClicked: false,
			isWidthReached: false
		};
		this.handleAddFilterClose = this.handleAddFilterClose.bind(this);
		this.handleAddFilterOpen = this.handleAddFilterOpen.bind(this);
		this.handleDetailDrawerOpen = this.handleDetailDrawerOpen.bind(this);
		this.handleDetailDrawerClose = this.handleDetailDrawerClose.bind(this);
		this.loadContentList = this.loadContentList.bind(this);
		this.nextPage = this.nextPage.bind(this);
		this.loadContentCount = this.loadContentCount.bind(this);
		this.filterChanged = this.filterChanged.bind(this);
		this.markAsFavourite = this.markAsFavourite.bind(this);
		this.setContentSelected = this.setContentSelected.bind(this);
		this.isInSelectedContent = this.isInSelectedContent.bind(this);
		this.isInDisableContent = this.isInDisableContent.bind(this);
		this._selectAllContent = this._selectAllContent.bind(this);
		this.selectPageItem = this.selectPageItem.bind(this);
		this.selectAllItem = this.selectAllItem.bind(this);
		this.moreMenuClicked = this.moreMenuClicked.bind(this);
		this.onDeleteConfirmed = this.onDeleteConfirmed.bind(this);
		this.onShared = this.onShared.bind(this);
		this.filterChip = this.filterChip.bind(this);
		this.removeContentFilter = this.removeContentFilter.bind(this);
		this.getTopSpacing = this.getTopSpacing.bind(this);
		this.createFilterData = this.createFilterData.bind(this);
		this.contentFilterDataChanged = this.contentFilterDataChanged.bind(this);
		this.fetchSearchResults = this.fetchSearchResults.bind(this);
		this.filterSearchAccordingToTags = this.filterSearchAccordingToTags.bind(this);
	}


	componentDidMount() {
		let { selectedContentType } = this.props;
		this.setState({ selectedContentType });
		const {selectedBucketType} = this.state
		const date = new Date();
		const academicYearEnd = date.getFullYear() + (date.getMonth() > MARCH_MONTH_INDEX ? 1 : 0);
		const academicYear = {
			startYear: ACADEMIC_YEAR_START,
			endYear: academicYearEnd
		}
		this.createAcademicList(ACADEMIC_YEAR_START, academicYearEnd);
		this.isUserTeacher = checkForTeacherUser(null, true);
		if(getUserType(USER_TYPE.STUDENT)) {
			this.state.filterContent.contentMenu = VALIDATION.CREATED_BY_ME;
		}
		if (!this.props.fromTestPaper) {
			let filtersData: any = localStorage.getItem('filtersData')
			let filtersDataCopy = JSON.parse(filtersData)
			filtersDataCopy = filtersDataCopy ? filtersDataCopy : {}
			let { filterContent, visibleFilters } = this.state
			filterContent = filterContent ? filterContent : {}
			if (filtersDataCopy.contentFilterData) {
				filterContent.contentFilterData = filtersDataCopy.contentFilterData
			}
			if (filtersDataCopy.visibleFilters) {
				visibleFilters = filtersDataCopy.visibleFilters
			}
			this.setState({
				filterContent: {...filterContent, bucketType: selectedBucketType, academicYear},
				visibleFilters,
				isRevert: true
			}, () => {
				this.loadContentList();
				this.loadContentCount();
			});

			// from testpaper
		} else if (this.props.fromTestPaper) {
			const { filterContent } = this.state;
			let filterDataToPass = JSON.parse(JSON.stringify(filterContent));
			filterDataToPass = this.changeFilterContent(filterDataToPass);
			this.setState({filterContent:{...filterDataToPass, bucketType: selectedBucketType, academicYear}},()=>{
				this.loadContentList();
				this.loadContentCount()
			});
		}
			//dispatch actions if not in store
			if (_.get(this.props, 'courses.list.length', 0) == 0) {
				this.props.coursesList();
			}
			// if (_.get(this.props, 'filterBy.list.length', 0) == 0) {
			// 	this.props.userFilterList();
			// }
			if (_.get(this.props, 'contentType.list.length', 0) == 0) {
				this.props.contentTypeList();
			}
			if (_.get(this.props, 'contentSubtype.list.length', 0) == 0) {
				this.props.contentSubtypeList();
			}
			if (_.get(this.props, 'contentSubtype.question.length', 0) == 0) {
				this.props.contentSubtypeByContentTypeCode("question");
			}
			// if (_.get(this.props, 'contentSubtype.testpapers.length', 0) == 0) {
			// 	this.props.contentSubtypeByContentTypeCode("testpapers");
			// }
			if (_.get(this.props, 'contentSubtype.studymaterial.length', 0) == 0) {
				this.props.contentSubtypeByContentTypeCode("studymaterial");
			}
			if (_.get(this.props, 'contentStatus.list.length', 0) == 0) {
				this.props.contentStatusList();
			}
			// if (_.get(this.props, 'contentTags.list.length', 0) == 0) {
			// 	this.props.contentTagsList();
			// }
			// if (_.get(this.props, 'classesData.list.length', 0) == 0) {
			// 	this.props.classesList();
			// }
	    this.checkWidth();
		window.addEventListener('resize', this.checkWidth);
	}

	componentWillReceiveProps(nextProps: any) {
		if (this.props.contentList != nextProps.contentList) {
			if (this.state.selectAllContent || this.state.selectedContentsAll) {
				this.setState({ selectedContents: nextProps.contentList })
			} else {
				this.setState({ selectedContents: [] });
			}
		}
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.checkWidth);
	}

	componentDidUpdate(prevProps: any) {
		const {contentSubtype, isQuestionSubtypeLoaded, isStudyMaterialSubtypeLoaded} = this.props;
		const {isFilterBuilt} = this.state;
		if(isQuestionSubtypeLoaded && isStudyMaterialSubtypeLoaded && !isFilterBuilt) {
			this.createFilterData();
		}
		if (_.isEmpty(this.state.selectedContents)) {
			if (this.props.selectedQuestions && this.props.selectedQuestions.length) {
				let { selectedQuestions } = this.props;
				this.setState({ selectedContents: selectedQuestions })
			}
		}

		if (prevProps.contentStatus !== this.props.contentStatus && isFilterBuilt) {
			this.createFilterData();
		}

	}

	giveTotalCountAfterFiltering = () => {
		const { filterSelectedQuestion, contentList } = this.props;
		let checkFromContent_Id = false;
		filterSelectedQuestion.map((ele: any) => {
			if (ele.hasOwnProperty('id')) {
				checkFromContent_Id = true;
			}
		});
		if (checkFromContent_Id) {
			const filteredValue = filterSelectedQuestion.map((ele: any) => ele.id ? ele.id : ele.content_Id);
			return contentList.filter((element: any) => !filteredValue.includes(element.content_Id)).length

		} else {
			const filteredValue = filterSelectedQuestion.map((ele: any) => ele.searchId ? ele.searchId : ele.contentId);
			return contentList.filter((element: any) => !filteredValue.includes(element.contentId)).length
		}
	}
	loadContentCount(): any {
		return new Promise((resolve: any, reject: any) => {
			const { filterContent } = this.state;
			const { filterSelectedQuestion } = this.props;
			contentService.count({...filterContent, allBucketCount: true}).then(res => {
				if (!this.props.fromNotes && filterSelectedQuestion && filterSelectedQuestion.length) {
					const filteredCount = this.giveTotalCountAfterFiltering()
					this.setState({ totalCount: filteredCount, bucketWiseCount: res.bucketWiseCount }, () => { resolve() });
				} else {
					this.setState({ totalCount: res.count, bucketWiseCount: res.bucketWiseCount }, () => { resolve() });
				}
			})
		})
	}

	getLimitForPagination() {
		return this.props.fromTestCreate ? 100 : 50;
	}

	getSelectedQuestionList() {
		const selectedQuestionList = this.props.filterSelectedQuestion || [];
		const selectedQuestionIdList = _.map(selectedQuestionList, (content) => _.get(content, 'content_Id', ''));

		return selectedQuestionIdList;
	}

	loadContentList(loader = true) {
		const { filterContent } = this.state;
		let filterDataToPass = JSON.parse(JSON.stringify(filterContent));

		filterDataToPass.excludedIds = this.getSelectedQuestionList();

		if (loader) {
			//  filterDataToPass=this.changeFilterContent(filterDataToPass);
			if (this.props.fromTestPaper) {
				this.props.contentActionList(filterDataToPass, this.state.currentPage, this.getLimitForPagination());
			}
			else {
				this.props.contentActionList(filterDataToPass, this.state.currentPage)
			}
		}
		else {
			this.props.contentActionList(filterDataToPass, this.state.currentPage, 20, false)
		}
	}

	changeFilterContent(filterDataToPass: any) {
		let testPaperFilter = _.get(filterDataToPass, "contentFilterData[0].filters[1]", {});
		if (this.props.selectedContentType && !_.isEmpty(testPaperFilter) && testPaperFilter.filterValue == "testpapers") {
			let subFilters = testPaperFilter.filters;
			if (this.props.selectedContentType === 'chapter' && subFilters.length > 0) {
				let newFilter = [];
				for (let i = 0; i < subFilters.length; i++) {
					if (subFilters[i].filterValue === 'chap') {
						newFilter.push(subFilters[i]);
					}
				}
				filterDataToPass.contentFilterData[0].filters[1].filters = newFilter;
			} else if (this.props.selectedContentType === 'concept' && subFilters.length > 0) {
				let newFilter = [];
				for (let i = 0; i < subFilters.length; i++) {
					if (subFilters[i].filterValue === 'concept') {
						newFilter.push(subFilters[i]);
					}
				}
				filterDataToPass.contentFilterData[0].filters[1].filters = newFilter;
			}
			this.setState({ filterContent: filterDataToPass });
		}
		return filterDataToPass;
	}

	filterChanged(loader = true) {
		this.setState({ currentPage: 1 });
		try {
			this.loadContentCount().then(() => {
				const { recentSelectedTag , tagsPool } =  this.state;
				if ((recentSelectedTag && recentSelectedTag.tagId) && (!tagsPool.length || 
					(tagsPool.length && !tagsPool.some((x:any) => x.tagId === recentSelectedTag.tagId)))) {
					tagsPool.unshift(recentSelectedTag);
				}
				this.setState({ tagsPool: tagsPool, recentSelectedTag: {}});
				this.loadContentList(loader);
			});
		} catch (ex) { }
	}

	nextPage(e: any, page: number) {
		let { selectedContents, dropdownSelectedValue } = this.state;
		if (dropdownSelectedValue == false) {
			this.setState({ currentPage: page, selectedContentsAll: false });
		} else {
			this.setState({ currentPage: page, selectedContentsAll: true });
		}
		if (!this.props.fromTestPaper) {
			this.setState({ selectedContents: [] });
		}
		setTimeout(() => {
			this.loadContentList();
		}, 200)
	}

	handleDetailDrawerOpen = (event: any, content: ContentData) => {
		event.preventDefault();
		this.setState({
			isDetailDrawerOpen: true,
			DetailDrawerContent: content
		});
	};

	handleDetailDrawerClose = (event: any) => {
		this.setState({
			isDetailDrawerOpen: false,
		});
	};

	contentMenuChanged = (contentMenu: string) => {
		let { filterContent, academicYearList } = this.state;
		filterContent.contentMenu = contentMenu;
		filterContent.questionStatus = '';
		if(VALIDATION.TABS.includes(contentMenu) && !this.props.fromTestPaper && this.isUserTeacher) {
			filterContent.questionStatus = ACADEMIC_STAT[contentMenu].COMPLETED.KEY;
			this.handleAcademicYearChange(academicYearList[1], true, true, true);
		} else {
			this.handleAcademicYearChange(academicYearList[0], true, false, true);
		}
		if (!this.props.fromTestPaper) {
			filterContent.goalsDriller = undefined;
			(filterContent.contentFilterData || []).forEach(filterType => {
				(filterType.filters || []).forEach(filter => {
					filter.isSelected = false;
					filter.disabled = false
					if(filter.filterValue === CONTENT_TYPE_FILTERS.QUESTION && VALIDATION.TABS.includes(contentMenu) && this.isUserTeacher) {
						filter.isSelected = true;
					}
					(filter.filters || []).forEach(subFilter => {
						subFilter.isSelected = filter.isSelected;
					})
				})
			})
		}
		this.setState({ filterContent, selectedContentsAll: false, selectAllContent: false, selectedContents: [] }, () => {
			this.filterChanged();
			if(this.isUserTeacher && !this.props.fromTestPaper) {
				if (VALIDATION.TABS.includes(contentMenu)) {
					this.getAcademicYearData();
					this.props.contentValidationStatusList(contentMenu);
				} else {
					this.props.contentStatusList();
				}
			}
		});
	}

	changeBucketType = (bucket: string) => {
		let { filterContent } = this.state;
		filterContent.bucketType = bucket;
		if (!this.props.fromTestPaper) {
			filterContent.goalsDriller = undefined;
		}
		if (filterContent.searchWithTags) {
		   delete filterContent.searchWithTags;
		}
		if (this.state.tempSearchText) {
			filterContent.searchText = this.state.tempSearchText;
		}
		this.setState({ filterContent, selectedContentsAll: false, selectAllContent: false, selectedContents: [], selectedBucketType: bucket, searchResults: [], tagsPool: [], recentSuggestions: [], recentTagsCount: 0});
		this.filterChanged();
	}

	goaldsDrillerChanged = (goalsDriller: GoalDrillerData) => {
		let { filterContent } = this.state;
		filterContent.goalsDriller = goalsDriller;
		this.setState({ filterContent });
		this.filterChanged();
	}

	contentFilterDataChanged = (
		contentFilterData: ContentFilterData[],
		isClearAll: boolean = false, visibleFilters: any = undefined, loader = true, callApi = true) => {
		let { filterContent } = this.state;
		filterContent.contentFilterData = contentFilterData;
		const obj: any = { contentFilterData }
		let { isAddFilterOpen } = this.state

		if (isClearAll) {
			visibleFilters = ['contentType', 'status', 'courses']
		}

		isAddFilterOpen = isClearAll ? true : false
		visibleFilters = visibleFilters ? visibleFilters : this.state.visibleFilters

		obj.visibleFilters = visibleFilters
		let selectedContentType = '';

		this.setState({ filterContent, isAddFilterOpen, visibleFilters, isRevert: false, isApply: false, selectedContentType });

		if (!this.props.fromTestPaper) {
			localStorage.setItem('filtersData', JSON.stringify(obj))
		}
		if (callApi) {
			this.filterChanged(loader);
		}
	}

	searchTextChanged = (searchText: string, keyEvent?: { key: string; }) => {
		let { filterContent } = this.state;
		filterContent.searchText = searchText;
		this.setState({ tempSearchText: searchText});
		if ((keyEvent && keyEvent.key === 'Enter') || searchText === '') {
			//api should not hi on each key stroke
			clearTimeout(this.searchInterval);
			this.clearSuggestions();
			this.resetTagClickedCounter();
			if (filterContent.searchWithTags) {
				delete filterContent.searchWithTags;
			}
			this.searchInterval = setTimeout(() => {
				this.filterChanged();
			}, 800);
		} else {
		   this.fetchSearchResults();
		}
	}

	markAsFavourite(i: number, isFavourite: number) {
		let id = this.props.contentList[i]._id
		contentService.markAsFavourite(id, isFavourite).then(() => {
			if (isFavourite == 0) {
				this.props.contentList[i].favourites = this.props.contentList[i].favourites.filter(id => id != this.props.userId);
			} else {
				this.props.contentList[i].favourites.push(this.props.userId);
			}

			this.forceUpdate();
		});
	}

	getAllContentListOnSelectAll = (allCount: number) => {
		const { filterContent } = this.state;
		contentService.list(filterContent, 1, allCount)
			.then(
				(res: any) => {
					const contentList = this.getSortedListBySearchText(res);
					this.props.onContentSelectAll(contentList, allCount);
				});
	}

	doSelectAll = (checked: boolean) => {
		let { fromMiniLibrary, contentList } = this.props;
		const { totalCount, filterContent } = this.state;
		if (checked) {
			contentList = contentList.sort((a, b) => a.contentId.localeCompare(b.contentId))
			this.setState({
				selectedContents: contentList/* , isShowShareDelete: true */
			});
			const allContentCount = this.state.selectAllContent ? totalCount : 0;
			if (this.props.onContentSelectAll) {
				if (allContentCount) {
					this.getAllContentListOnSelectAll(allContentCount)
				} else {
					contentList = this.getSortedListBySearchText(contentList)
					this.props.onContentSelectAll(contentList, allContentCount);
				}

			}
			if (fromMiniLibrary) {
				this.props.handleSelectAll(true, totalCount, filterContent, this.state.isAllPages, contentList)
			}
		} else {
			this.setState({ selectedContents: []/* , isShowShareDelete: false */ })
			if (this.props.onContentSelectAll) {
				this.props.onContentSelectAll([]);
			}
			if (fromMiniLibrary) {
				this.props.handleSelectAll(false, 0, "", this.state.isAllPages, [])
			}
		}
	}

	_selectAllContent(e: any, checked: boolean) {
		this.setState({ selectedContentsAll: checked }, () => {
			if (this.state.selectedContentsAll) {
				this.setState({ selectAllContent: false, isAllItemSelected: false })
			}
			this.doSelectAll(checked)
		})
	}

	selectAllItem = () => {
		this.setState({
			selectAllContent: !this.state.selectAllContent
		}, () => {
			if (this.state.selectAllContent) {
				this.setState({ selectedContentsAll: false, isAllItemSelected: false })
			}
			this.doSelectAll(this.state.selectAllContent)
		});
	}

	compareContentIds(passageData: any[], contentIds: any[]) {
		if (passageData) {
			return JSON.stringify(passageData.map((p: any) => p.contentId)) === JSON.stringify(contentIds)
		}
		return false
	}

	isInSelectedContent(id: string, content_Id: string = "", passageData: any[] = []) {
		const { selectedContents, dropdownSelectedValue, selectedContentsAll } = this.state;
		const { selectedContentCourse, fromCourse, onCheckContentExist } = this.props;
		const contentIds = passageData.map(p => p.contentId);
		if (selectedContents.filter(c => (c._id == id || c.content_Id == content_Id ||
			(this.compareContentIds(c.passageData, contentIds))
		)).length || (dropdownSelectedValue && selectedContentsAll)) {
			return true;
		}
		if (onCheckContentExist) {
			return onCheckContentExist(content_Id)
		}
		return false
	}

	isInDisableContent(_id: string, content_Id: string = "") {
		const { onCheckContentExist } = this.props;
		if (onCheckContentExist) {
			return onCheckContentExist(content_Id)
		}
		return false
	}


	setContentSelected(c: ContentData, checked: boolean) {
		let { selectedContents, unselectedContents/* , isShowShareDelete */ } = this.state;
		let newSelectedContents = [...selectedContents];
		let newUnSelectedContents = [...unselectedContents];
		if (checked) {
			newSelectedContents.push(c);
		} else {
			newSelectedContents = newSelectedContents.filter(sc => {
				if (sc._id == c._id) {
					return false;
				}
				if ((sc.content_Id) && c.content_Id && (sc.content_Id === c.content_Id)) {
					return false;
				}
				return true;
				// sc._id != c._id && sc.content_Id != c.content_Id
			});
			newUnSelectedContents.push(c._id);

		}
		newUnSelectedContents = newUnSelectedContents.filter((item, index) => newUnSelectedContents.indexOf(item) === index);
		// newSelectedContents = this.props.fromCourseMangement ? newSelectedContents.filter((n: any) => n.id !== c.content_Id || n.content_Id === c.content_Id) : newSelectedContents;
		newSelectedContents = this.props.fromTestPaper ? newSelectedContents.sort((a, b) => a && a.content && a.contentId.localeCompare(b.contentId)) : newSelectedContents

		this.setState({ unselectedContents: newUnSelectedContents, selectedContents: newSelectedContents, selectedContentsAll: false, selectAllContent: false })

		if (this.props.onContentSelect) {
			const contentList = this.getSortedListBySearchText(newSelectedContents);
			this.props.onContentSelect(contentList);
		}
	}

	moreMenuClicked(item: string) {
		if (this.state.selectedContents.length == 0 && !this.state.selectAllContent) {
			return false;
		}
		//perform on selected content
		if (item == "Delete") {
			this.setState({ isDeleteDialogOpen: true });
		}
		//perform on selected content
		if (item == "Share") {
			if (this.state.filterContent.contentMenu !== SHAREDWITHMEKAY) {
				this.setState({ isShareDialogOpen: true });
			}
		}
	}

	onDeleteConfirmed(action: boolean) {
		this.setState({ isDeleteDialogOpen: false });

		if (action) {
			setTimeout(() => {
				this.loadContentList();
			}, 500)

			this.clearSelectedContent();
		}
	}
	//URL = window.location.href;
	getURL = window.location.href;

	onShared(shared: boolean) {
		this.setState({ isShareDialogOpen: false });
		let t = 300;

		if (this.state.selectedContentsAll) {
			t = t * 20;
		} else {
			t = t * this.state.selectedContents.length;
		}

		if (shared) {
			setTimeout(() => {
				this.loadContentList();
			}, t)

			this.clearSelectedContent();
		}
	}

	clearSelectedContent() {
		this.setState({ selectedContentsAll: false, selectedContents: [] })
	}

	filterChip(showEmptyFilter: boolean = false) {
		const { filterContent } = this.state;
		const { classes } = this.props;
		let isfilterApplied = false
		const chips = _.map(filterContent.contentFilterData, (ff, i: number) => {

			return _.map(ff.filters, (fc, j: number) => {

				let name = fc.filterTitle

				if (!fc.isSelected || !name) {
					return;
				} else {
					isfilterApplied = true
				}

				if (fc.filters && fc.filters.length > 0) {
					name += ": " + fc.filters.filter(f => f.isSelected)
						.map((f: any) => f.filterTitle).join(",");
				}

				return (
					this.getURL.includes("edit") != true ?
						<Chip
							key={j}
							label={name}
							onDelete={() => { this.getURL.includes("mylibrary") === true ? this.removeContentFilter(i, j) : false }}
							classes={{ root: classes.filterChip }}
						/> :
						<Chip
							key={j}
							label={name}
							onDelete={() => { }}
							classes={{ root: classes.filterChip }}
						/>
				)
			})
		}
		)

		return isfilterApplied ? (<div>{chips}</div>) : showEmptyFilter ? 'No filters applied yet, apply filters from below' : ''
	}

	removeContentFilter(i: number, j: number) {
		const { filterContent } = this.state;

		if (filterContent.contentFilterData) {

			filterContent.contentFilterData[i].filters[j].isSelected = false;
			filterContent.contentFilterData[i].filters[j].filters = _.map(filterContent.contentFilterData[i].filters[j].filters, (f) => {
				f.isSelected = false;
				return f;
			})


			this.contentFilterDataChanged(filterContent.contentFilterData);
		}

	}
	checkDeletePermission() {
		let disable = false;
		this.state.selectedContents.forEach((ele: any) => {
			disable = disable || !ACLService.checkModulePermission(ele.contentTypeCode, "edit")
		})
		return disable;
	}

	getTopSpacing(topSpacing: number) {
		// this.setState((state, props) => ({topSpacing}));
		// this.setState((state, props) => ({ topSpacing }));
	}
	changeLimit(event: any) {
		let that = this
		if (event.target.value === 'allPages') {
			this.setState({ isAllPages: true, dropdownSelectedValue: true }, function () {
				if (that.state.selectedContentsAll) {
					that._selectAllContent({}, that.state.selectedContentsAll)
				}
			})
		}
		else {
			this.setState({ isAllPages: false, dropdownSelectedValue: false }, function () {
				if (that.state.selectedContentsAll) {
					that._selectAllContent({}, that.state.selectedContentsAll)
				}
			})
		}
		// this.props.contentActionList(filterContent, this.state.currentPage,event.target.value);
	}

	handleGoalsSectionClick(value: boolean) {

		this.setState({
			areGoalsSectionClicked: value
		})
	}
	// const [open, setOpen] = React.create(false);

	handleAddFilterOpen = (event: any) => {
		this.setState({
			isAddFilterOpen: true,
		});
	}

	handleAddFilterClose = (event: any) => {
		this.setState({
			isAddFilterOpen: false,
		});
	}

	filterExpandClick = (value: any) => {
		this.setState({
			expandedFilter: !this.state.expandedFilter
		})
	}

	createFilterData() {
		const { contentStatus, contentType, contentSubtype, contentTags, courses, filterBy, classesData } = this.props;

		const { filterContent } = this.state
		const { fromTestPaper } = this.props
		let filterData: any = [];
		const questionFiltersToRemove = AUTHORING_QUESTION_CONTENT_TYPES.filter(type => type !== AUTHORING_CONTENT_TYPES.GLORIFIRE_QUESTION);
      	const testFiltersToRemove = AUTHORING_TEST_CONTENT_TYPES.filter(type => type !== AUTHORING_CONTENT_TYPES.GLORIFIRE_TESTPAPERS);
		const contentFiltersToRemove = [...questionFiltersToRemove, ...testFiltersToRemove, ...CONTENT_TYPES_TO_HIDE_FROM_FILTER];
		const currentYear = new Date().getFullYear();
		const previousYears = Array.from(Array(currentYear - PREVIOUS_CONTENT_START_YEAR + 1).keys(), i => i + PREVIOUS_CONTENT_START_YEAR).map(String);


		//create content filter
		let contentFilter: any = {
			filterTitle: 'Content Type',
			filterValue: 'contentType',
			isSelected: false,
			disabled: false,
			filters: []
		}

		_.map(contentType.list, ct => {
			if(contentFiltersToRemove.includes(ct.code)) return null;
			let ctf: any = {
				filterTitle: ct.name,
				filterValue: ct.code,
				isSelected: false,
				disabled: false,
				filters: []
			}
			if (ct.code == "question") {
				_.map(contentSubtype.question, q => {
					let qf: any = {
						filterTitle: q.name,
						filterValue: q.code,
						isSelected: false,
						disabled: false,
						filters: []
					}

					ctf.filters.push(qf);
				});
			}
			if (ct.code == 'studymaterial') {
				_.map(contentSubtype.studymaterial, t => {
					let tf: any = {
						filterTitle: t.name,
						filterValue: t.code,
						isSelected: false,
						disabled: false,
						filters: []
					};
					ctf.filters.push(tf);
				})
			}

			contentFilter.filters.push(ctf);
		})


		//create status filter
		let statusFilter: any = {
			filterTitle: 'Status',
			filterValue: 'status',
			isSelected: false,
			disabled: false,
			filters: []
		}

		_.map(contentStatus.list, cs => {
			let ctf: any = {
				filterTitle: cs.name,
				filterValue: cs.code,
				isSelected: false,
				disabled: false,
				filters: []
			}

			statusFilter.filters.push(ctf);
		});

		//previous year filter
		let previousYearFilter: any = {
			filterTitle: 'Previous Year Content',
			filterValue: FILTER_CATEGORIES.PREVIOUS_YEAR_CONTENT,
			isSelected: false,
			disabled: false,
			filters: []
		}

		previousYears.forEach((year: any) => {
			let yearFiler: any = {
				filterTitle: year,
				filterValue: year,
				isSelected: false,
				disabled: false,
				filters: []
			}
			previousYearFilter.filters.push(yearFiler);
		})

		// difficulty filter
		let difficulties = ['Easy', 'Medium', "Difficult"]
		let difficultyFilter: any = {
			filterTitle: "Difficulty",
			filterValue: "difficulty",
			isSelected: false,
			disabled: false,
			filters: []
		}

		_.map(difficulties, (difficulty: any) => {
			let ctf: any = {
				filterTitle: difficulty,
				filterValue: difficulty,
				isSelected: false,
				disabled: false,
				filters: []
			}
			difficultyFilter.filters.push(ctf);

		});

		// skill filter
		let skills = ['Conceptual', 'Analytical', "Intuitive"]
		let skillFilter: any = {
			filterTitle: "Skill",
			filterValue: "skill",
			isSelected: false,
			disabled: false,
			filters: []
		}

		_.map(skills, (skill: any) => {
			let ctf: any = {
				filterTitle: skill,
				filterValue: skill,
				isSelected: false,
				disabled: false,
				filters: []
			}

			skillFilter.filters.push(ctf);

		});

		//set data
		filterData.push(statusFilter);
		filterData.push(contentFilter);
		filterData.push(previousYearFilter);
		filterData.push(difficultyFilter);
		filterData.push(skillFilter);
		filterData = [...filterData];

		filterData = filterData.filter((f: any) => !_.isEmpty(f))
		const { contentFilterData } = filterContent
		if (contentFilterData && contentFilterData.length) {
			contentFilterData.forEach((icf: any) => {
				filterData.forEach((f: any) => {

					//found upper level - content type, status
					if (icf.filterValue == f.filterValue) {

						icf.filters.forEach((icff: any) => {
							f.filters.forEach((ff: any) => {

								if (fromTestPaper) {
									ff.disabled = true
								}
								//found level 2 - question, study material
								if (icff.filterValue == ff.filterValue) {
									ff.isSelected = icff.isSelected
									ff.filters.forEach((fff: any) => {
										icff.filters.forEach((icfff: any) => {
											if (fromTestPaper) {
												fff.disabled = true
											}
											//found level 3 - mcq, mmcq
											if (icfff.filterValue == fff.filterValue) {
												if (this.props.selectedContentType === 'chapter') {
													if (fff.filterValue === 'concept') {
														fff.isSelected = false
													} else {
														fff.isSelected = icfff.isSelected;
													}
												} else if (this.props.selectedContentType === 'concept') {
													if (fff.filterValue === 'chap') {
														fff.isSelected = false;
													} else {
														fff.isSelected = icfff.isSelected;
													}
												} else {
													fff.isSelected = icfff.isSelected;
												}
											}
										})
									})
								}
							})
						})
					}
				})
			})
		}
		filterContent.contentFilterData = filterData;

		this.setState({ filterContent, isFilterBuilt: true });
	}

	handleHover = () => {
		this.setState({
			showTooltipExpand: !this.state.showTooltipExpand
		})
	}

	selectPageItem = (e: any) => {
		this.setState({
			isAllItemSelected: !this.state.isAllItemSelected,
			anchorEl: e.currentTarget
		});
	}

	showStatusList = () => {
		const { classes } = this.props;
		return (<>
			<FormGroup>
				<FormControlLabel
					control={
						<Checkbox classes={{
							root: classes.checkBoxElement,
							checked: classes.checkedCheckbox,
							colorPrimary: classes.primaryColor
						}}
							checked={true}
							color="primary"
							value="Question Types" />
					}
					label="Published(210)"
					classes={{ label: classes.checkboxLabel, root: classes.formControlLabel }}
				/>

				<FormControlLabel
					control={
						<Checkbox classes={{
							root: classes.checkBoxElement,
							checked: classes.checkedCheckbox,
							colorPrimary: classes.primaryColor
						}}
							checked={true}
							color="primary" value="Study Material" />
					}
					label="Draft(200)"
					classes={{ label: classes.checkboxLabel, root: classes.formControlLabel }}
				/>

				<FormControlLabel
					control={
						<Checkbox classes={{
							root: classes.checkBoxElement,
							checked: classes.checkedCheckbox,
							colorPrimary: classes.primaryColor
						}}
							checked={true}
							color="primary" value="Test Papers" />
					}
					label="In Review(20)"
					classes={{ label: classes.checkboxLabel, root: classes.formControlLabel }}
				/>
			</FormGroup>
		</>);
	}

	showContentTypes = () => {
		const { classes } = this.props;
		return (<>
			<FormGroup>
				<FormControlLabel
					control={
						<Checkbox classes={{
							root: classes.checkBoxElement,
							checked: classes.checkedCheckbox,
							colorPrimary: classes.primaryColor
						}}
							checked={true}
							color="primary" value="Question Types" />
					}
					label="Question Types(210)"
					classes={{ label: classes.checkboxLabel, root: classes.formControlLabel }}
				/>

				<FormControlLabel
					control={
						<Checkbox classes={{
							root: classes.checkBoxElement,
							checked: classes.checkedCheckbox,
							colorPrimary: classes.primaryColor
						}}
							checked={true}
							color="primary" value="Study Material" />
					}
					label="Study Material(2100)"
					classes={{ label: classes.checkboxLabel, root: classes.formControlLabel }}
				/>

				<FormControlLabel
					control={
						<Checkbox classes={{
							root: classes.checkBoxElement,

							colorPrimary: classes.primaryColor
						}}
							checked={true}
							color="primary" value="Test Papers" />
					}
					label="Test Papers(2100)"
					classes={{ label: classes.checkboxLabel, root: classes.formControlLabel }}
				/>
			</FormGroup>
		</>);
	}

	multipleSelectOption = () => {
		const { classes, fromTestPaper, contentList } = this.props;
		const { anchorEl,
			totalCount,
			isAllItemSelected,
			selectedContentsAll,
			selectAllContent
		} = this.state;
		return (<Popover
			className={classes.marginTop1x}
			classes={{ paper: classes.popoverRoot }}
			id="simple-menu"
			elevation={8}
			anchorEl={anchorEl}
			anchorReference='anchorEl'
			anchorOrigin={{
				vertical: 'bottom',
				horizontal: 'left',
			}}
			transformOrigin={{
				vertical: 'top',
				horizontal: 'left',
			}}
			open={isAllItemSelected}
			onClose={() => this.setState({
				isAllItemSelected: !this.state.isAllItemSelected
				, setAnchorEl: null
			})}
		><MenuList classes={{ padding: classes.paddingZero }}>
				<MenuItem>
					<ListItemIcon classes={{ root: classes.listItemIcon }}>
						<Checkbox
							onChange={this._selectAllContent}
							checked={selectedContentsAll}
							classes={{
								root: classes.checkbox,
								checked: classes.SelectCheckedCheckbox,
								colorPrimary: classes.primaryColor
							}}
							color="primary" disableRipple />
					</ListItemIcon>
					<Typography variant="inherit" color="secondary" classes={{ colorSecondary: classes.lightGrey }}>
						Select Item on this Page ({this.removeSelectedQuestionFromContent().length})
					</Typography>
				</MenuItem>
				{(!this.props.fromTestPaper || this.props.fromCourseMangement) &&
					<MenuItem>
						<ListItemIcon classes={{ root: classes.listItemIcon }}>
							<Checkbox
								onChange={this.selectAllItem}
								checked={selectAllContent}
								classes={{
									root: classes.checkbox,
									checked: classes.SelectCheckedCheckbox,
									colorPrimary: classes.primaryColor
								}}
								color="primary" disableRipple />
						</ListItemIcon>
						<Typography variant="inherit" color="secondary" classes={{ colorSecondary: classes.lightGrey }}>
							Select All Search Result ({totalCount})
						</Typography>
					</MenuItem>
				}
			</MenuList>
		</Popover>
		);
	}

	onFilterSelect = (e: any, subFilterType: any, filterType: any) => {
		const { filterContent: filterContentFromState } = this.state
		const filterContent: ContentListFilterData = JSON.parse(JSON.stringify(filterContentFromState));
		if (filterContent.contentFilterData) {
			let index = filterContent.contentFilterData.findIndex(item => item.filterValue == filterType)
			if (index != -1) {
				let subIndex = filterContent.contentFilterData[index].filters.findIndex(item => item.filterValue == subFilterType)
				if (subIndex != -1) {
					filterContent.contentFilterData[index].filters[subIndex].isSelected = e.target.checked
					if (e.target.checked === false) {
						filterContent.contentFilterData[index].filters[subIndex].filters.forEach((thirdLevelFilter) => {
							thirdLevelFilter.isSelected = false
						})
					}
				}
			}
			this.setState({
				filterContent,
				isApply: true
			})
		}
	}

	renderSubFilters(list: any[], type: string) {
		const { classes } = this.props;
		if (this.state.selectedBucketType !== CONTENT_SECTION_KEYS.GLORIFIRE) {
			list = list.filter(item => item.filterValue !== contentTypesForContentHistoryMap.studymaterial);
		}
		const status = type !== CARD_STATUS.FILTER_STATUS;
		if (status) {
			list = list.filter(item => this.filters[type].subFilters[item.filterValue])
		}
		list = list.map(item => (
			<FormControlLabel
				control={<Checkbox
					classes={{
						root: classes.checkBoxElement,
						checked: classes.checkedCheckbox,
						colorPrimary: classes.primaryColor
					}}
					color="primary"
					onChange={(e: any) => this.onFilterSelect(e, item.filterValue, type)}
					checked={item.isSelected} value={item.filterValue} />}
				classes={{ label: classes.checkboxLabel, root: classes.formControlLabel }}
				label={`${item.filterTitle}`}
			/>
		));
		return <FormGroup>
			<PerfectScrollbar className={classes.filterPaper}>
				{list}
			</PerfectScrollbar>
		</FormGroup>;
	}

	renderFilters() {
		const { filterContent, areGoalsSectionClicked, expandedFilter } = this.state

		const { classes, fromTestPaper } = this.props
		let filterList: any = (filterContent.contentFilterData &&
			filterContent.contentFilterData
				.filter(item => this.filters[item.filterValue] && this.filters[item.filterValue].visible)) || []
		return filterList.map((item: any) => {
			return (
				<Card
					className={cx(
						{
							[classes.fixedSection]: !areGoalsSectionClicked,
							[classes.fixedSectionScroll]: areGoalsSectionClicked
						},
						fromTestPaper ? classes.fromTestPaper : ""
					)}
				>
					<CardHeader
						action={
							<>
								<div className={classes.marginTop1x}>
									<IconButton
										className={cx(classes.expand, {
											[classes.expandOpen]: !expandedFilter
										})}
										onClick={(e) => this.filterExpandClick(e.target)}
										aria-expanded={expandedFilter}
										aria-label="show more"
										id={item.filterTitle}
									>
										<ExpandMoreIcon fontSize="small" height="1.5em" />
									</IconButton>
								</div>
							</>
						}
						title={
							<Typography component="h6" variant="body1">
								{item.filterTitle}
							</Typography>
						}
						className={classes.cardHeader}
					/>
					<Collapse className={classes.fullWidth} in={expandedFilter} timeout="auto" unmountOnExit>
						<CardContent className={classes.scrollBarX}>
							<PerfectScrollbar>{this.renderSubFilters(item.filters, item.filterValue)}</PerfectScrollbar>
						</CardContent>
					</Collapse>
				</Card>)
		})
	}

	removeSelectedQuestionFromContent = () => {
		const { contentList } = this.props;
		return contentList;
	}


	getIndexOfQuestion(question: ContentData, questionIndexMap: Map<string, number>) {
		const passageData = _.get(question, "passageData", [{ contentId: question.contentId }])
		let minIndex = questionIndexMap.get(passageData[0].contentId) || Number.POSITIVE_INFINITY;

		passageData.forEach((questionData: any) => {
			const currentQuestionIndex = questionIndexMap.get(questionData.contentId) || Number.POSITIVE_INFINITY;
			minIndex = Math.min(minIndex, currentQuestionIndex);
		});

		return minIndex;
	}

	getSortedListBySearchText(contentList: ContentData[]): ContentData[] {
		let { filterContent: { searchText = '' } } = this.state;

		searchText = searchText.trim();
		let questionCodeList = searchText.split(',');

		if (!questionCodeList.length) {
			return contentList;
		}

		const questionIndexMap = new Map<string, number>()
		questionCodeList.forEach((question: string, index: number) => {
			question = question.trim();
			questionIndexMap.set(question, index + 1);
		})

		contentList = contentList.sort((questionOne: ContentData, questionTwo: ContentData) => {
			const firstIndex = this.getIndexOfQuestion(questionOne, questionIndexMap);
			const secondIndex = this.getIndexOfQuestion(questionTwo, questionIndexMap);
			return firstIndex - secondIndex;
		})

		return contentList;
	}


	shiftActiveAcademicYear = (shiftValue: number) => {
		const { filterContent } = this.state;
		const academicYear = createDeepCopy(this.state.academicYear)
		if (filterContent.contentMenu === VALIDATION.CREATED_BY_ME) {
			academicYear.createdByMeActiveIndex += shiftValue;
		}
		else {
			academicYear.validationRequestActiveIndex += shiftValue;
		}

		this.setState({ academicYear });
	}

	startNewValidation = (type: any) => {
		contentRequestServices.startNewValidation(type.value).then((res: any) => {
			const { contentId, contentType } = res;
			if (contentId && contentType) {
				window.open('/content/preview/' + contentId + contentType);
			} else {
				this.props.showMsg('There are no questions in the validation pool available for you. Please try after sometime', VARIANT.WARNING);
			}
		});
	};

	createAcademicList = (start: number, end: number) => {
		const academicYearList = [];
		academicYearList.push({key: end, label: 'All Academic Year'});
		for (let year = end - 1; year >= start; year--) {
			academicYearList.push({ key: year, label: `Academic Year ${year}-${year + 1}` });
		}
		this.setState({ academicYearList, selectedAcademicYearList: academicYearList.map(year => year.key).sort() });
	}

	handleAcademicYearChange = (selectedOption: any, isSelectedOption: boolean, selectSingle?: boolean, skipApiCall?: boolean) => {
		const { academicYearList, selectedAcademicYearList, filterContent } = this.state;
		if(!academicYearList.length){
			return;
		}
		let maximumYear = Math.max(...selectedAcademicYearList);
		let minimumYear = Math.min(...selectedAcademicYearList);
		const newYear = getPropertyValue(selectedOption, 'key', minimumYear);
		if(selectSingle) {
			minimumYear = newYear;
			maximumYear = newYear;
		} else {
			if (isSelectedOption) {
				minimumYear = Math.min(minimumYear, newYear);
				maximumYear = Math.max(maximumYear, newYear);
				if(maximumYear === academicYearList[0].key) {
					minimumYear = academicYearList[academicYearList.length - 1].key;
				}
			} else {
				if(maximumYear === academicYearList[0].key) {
					if(newYear === academicYearList[0].key) {
						maximumYear = minimumYear = 0;
					} else {
						maximumYear = academicYearList[1].key;
						minimumYear = newYear;
					}
				} else if(maximumYear === minimumYear) {
					minimumYear = maximumYear = 0;
				} else {
					if (maximumYear === newYear) {
						maximumYear--;
					} else {
						minimumYear = newYear + 1;
					}
				}
			}

			if (minimumYear > maximumYear) {
				minimumYear = getPropertyValue(academicYearList[1], 'key');
				maximumYear = minimumYear;
			}
			if(maximumYear === academicYearList[1].key && minimumYear === academicYearList[academicYearList.length -1].key) {
				maximumYear++;
			}
		}

		const newSelectedAcademicYearList: any[] = [];
		for (let year = minimumYear; year && year <= maximumYear; year++) {
			newSelectedAcademicYearList.push(year);
		}
		filterContent.academicYear = {
			startYear: minimumYear || 1,
			endYear: maximumYear + 1,
		}
		this.setState({ selectedAcademicYearList: newSelectedAcademicYearList, filterContent }, () => {
			if(!skipApiCall) {
				this.filterChanged(true);
				if (VALIDATION.TABS.includes(filterContent.contentMenu || '') && this.isUserTeacher) {
					this.getAcademicYearData();
				}
			}
		});
	}

	getAcademicYearData = () => {
		const {selectedAcademicYearList} = this.state;
		if(this.props.fromTestPaper) return;
		const statType = this.state.filterContent.contentMenu === VALIDATION.CREATED_BY_ME ? statYear.AUTHOR : statYear.VALIDATOR;
		const startYear = selectedAcademicYearList[0] || '', endYear = selectedAcademicYearList[selectedAcademicYearList.length - 1] + 1 || '';
		contentRequestServices.getAcademicYearList(statType, startYear, endYear).then((academicDetails: any) => {
			this.setState({ academicYear: academicDetails.academicData || {} });
		});
	}

	publishInReviewQuestions = () => {
		const { selectedContents } = this.state;
		const selectedContentIds = selectedContents.map(content => content.content_Id);
		contentService.publishInreviewContents({ questionIds: selectedContentIds }).then((res: any) => {
			this.filterChanged();
			this.setState({
				isPublishDirectlyModalOpen: false,
			});
		})
	}

	onPublishDirecltyModalClose = () => {
		this.setState({ isPublishDirectlyModalOpen: false });
	}
	handleGoalsDrillerToggle = () => {
		const {isGoalsDrillerOpen} = this.state;
		this.setState({
			isGoalsDrillerOpen: !isGoalsDrillerOpen,
		})
	}

	handleFilterToggle = () => {
		const {isSideFilterOpen} = this.state;
		this.setState({
			isSideFilterOpen: !isSideFilterOpen,
		})
	}

	handleFilterSelected = (updatedFilters: any) => {
		const {filterContent} = this.state;
		filterContent.contentFilterData = updatedFilters;
		const contentMenu = filterContent.contentMenu || '';
		if(this.isUserTeacher && VALIDATION.TABS.includes(contentMenu) && !this.props.fromTestPaper) {
			if(this.checkOnlyQuestionSelected(filterContent)) {
				if(!filterContent.questionStatus) {
					filterContent.questionStatus = ACADEMIC_STAT[contentMenu].COMPLETED.KEY;
				}
			} else {
				filterContent.questionStatus = '';
				const statusFilter: any = (updatedFilters || []).find((filterCategory: any) => filterCategory.filterValue === FILTER_CATEGORIES.STATUS) || {};
				(statusFilter.filters || []).forEach((filter: any) => {
					filter.disabled = false;
				})
			}
		}
		this.setState({
            filterContent,
			isSideFilterOpen: false,
        }, () => {this.filterChanged(true)});
	}

	handleQuestionStatusChange = (status: string) => {
		const {filterContent} = this.state;
        filterContent.questionStatus = status;
		const contentMenu = filterContent.contentMenu || '';
		if(this.isUserTeacher) {
			const statusFilter: any = (filterContent.contentFilterData || []).find((filterCategory: any) => filterCategory.filterValue === FILTER_CATEGORIES.STATUS) || {};
			(statusFilter.filters || []).forEach((filter: any) => {
				filter.disabled = status && status !== ACADEMIC_STAT[contentMenu].COMPLETED.KEY;
				filter.isSelected = filter.filterValue === status;
			})
		}
        this.setState({
            filterContent,
        }, () => {this.filterChanged(true)});
	}

	checkOnlyQuestionSelected = (updatedFilter ?: any): boolean => {
		const { filterContent } = this.state;
		const selectedFilterTypes: any = [];
		const filterUsed = Object.keys(updatedFilter || {}).length ? updatedFilter : filterContent;
		const contentType: any = (filterUsed.contentFilterData || []).find((filterCategory: any) => filterCategory.filterValue === FILTER_CATEGORIES.CONTENT_TYPE) || {};
		(contentType.filters || []).forEach((filterType: any) => {
			filterType.isSelected && selectedFilterTypes.push(filterType.filterValue);
		})

		return selectedFilterTypes.length === 1 && selectedFilterTypes[0] === CONTENT_TYPE_FILTERS.QUESTION;
	}

	handleValidationInfoDialogOpen = () => {
		this.setState({
			legendDialogVisible: true,
			validationDialogInfoType: VALIDATION_DIALOG_INFO_TYPES.OTHER,
		});
	}

	getRecentSuggestions = () => {
	  try {
		const {selectedBucketType} = this.state;
		contentRequestServices.fetchRecentSuggestions(selectedBucketType).then((response) => {
			if (response && response.statusCode === 200) {
				const { responseObject } = response;
				this.setState({ recentSuggestions: responseObject, isSearchBoxClicked: true });
			} else if (API_ERROR_CODES.includes(response.statusCode)) {
				this.setState({ recentSuggestions: [] });
				this.props.showMsg((response.message || DEFAULT_ERROR_MSG), VARIANT.ERROR);
			}
		})
	  } catch (err) {
		this.props.showMsg(DEFAULT_ERROR_MSG , VARIANT.ERROR);
	  }
	}

	clearSuggestions = () => {
		this.setState({ recentSuggestions: [] , searchResults: [], isSearchBoxClicked: false});
	}
	
	addSuggestionsToTagsPool = (payload: any) => {
		try {
			const { tagsPool, selectedBucketType } = this.state;
			this.setState({ recentSelectedTag: payload});
			payload.bucketType = selectedBucketType;
			contentRequestServices.addTagsToRecentSearchResults(selectedBucketType, payload).then((response: any) => {
				if (response && response.statusCode === 200) {
					this.filterSearchAccordingToTags();
				} else if (API_ERROR_CODES.includes(response.statusCode)) {
					this.props.showMsg(response.responseMessage || DEFAULT_ERROR_MSG, VARIANT.ERROR);
					this.setState({recentSelectedTag: {}});
				}
			})
		} catch (e) {
			this.props.showMsg(DEFAULT_ERROR_MSG, VARIANT.ERROR);
		}
	}


	fetchSearchResults() {
		try {
		  const query = {
			searchText: this.state.filterContent.searchText,
			bucketType: this.state.selectedBucketType
		  }
		  contentRequestServices.fetchSearchResults(query).then((response: any) => {
			if (response && response.statusCode === 200) {
				const { responseObject } = response;
				this.setState({ searchResults: responseObject.tags || []})
			} else if (API_ERROR_CODES.includes(response.statusCode)) {
				this.setState({ searchResults: [] });
			}
		 })
		} catch (e) {
			this.setState({searchResults: []})
		}
	}

	filterSearchAccordingToTags(recentTag?: any) {
		try {
			if (this.state.recentTagsCount) {
				const { tagsPool, recentTagsCount, recentSelectedTag } = this.state;
				const recentClickedTagsPool = tagsPool.length ? tagsPool.slice(-recentTagsCount) : [];
				recentClickedTagsPool.push(recentSelectedTag);
				let { filterContent } = this.state;
				filterContent.searchWithTags = recentClickedTagsPool.map((filterContent: any) => {
					return {tagId: filterContent.tagId, tagType: filterContent.tagType};
				});
				this.setState({ filterContent });
				if (filterContent.searchText) {
					 delete filterContent.searchText;
				}
				this.filterChanged();
				this.checkWidth();
			} else if (recentTag) {
				let { filterContent } = this.state;
				filterContent.searchWithTags = [{tagId: recentTag.tagId, tagType: recentTag.tagType}];
				this.setState({ filterContent });
				if (filterContent.searchText) {
					delete filterContent.searchText;
				}
				this.filterChanged();
			}
		} catch (e) {
			let { filterContent } = this.state;
			filterContent.searchWithTags = [];
			filterContent.searchText = '';
			this.setState({ filterContent });
		}
	}

	increaseTagClickedCount  = () => {
		let { recentTagsCount } =  this.state;
		recentTagsCount++;
		this.setState({ recentTagsCount });
	}

	resetTagClickedCounter = () => {
		this.setState({ recentTagsCount: 0 });
	}

	removeTagFromTagPool = (index: number) => {
		let { tagsPool, filterContent } = this.state;
		if (filterContent.searchWithTags && filterContent.searchWithTags.length) {
			let _index = (filterContent.searchWithTags.findIndex(x => x.tagId && tagsPool[index].tagId));
			_index > -1 && filterContent.searchWithTags.splice(_index, 1);
			this.filterChanged();
		}
        tagsPool.splice(index, 1);
        this.setState({ tagsPool });
		this.checkWidth();
	}

	clearAllTags= () => {
		this.setState({ tagsPool: [], recentTagsCount: 0, clearTagModal: false });
		this.props.showMsg(CLEAR_ALL_TAGS_TOASTER_MSG, VARIANT.SUCCESS);
		let { filterContent } = this.state;
		filterContent.searchWithTags = [];
		filterContent.searchText = '';
		this.filterChanged();
	}

	clearSearchResults = () => {
		this.setState({searchResults: []});
	}

	checkWidth = () => {
		if (this.ulRef) {
		 const container = this.ulRef;
		 if (container && container.children) {
		   const containerWidth = container.getBoundingClientRect().width;
		   const childrenWidth =  Array.from(container.children).reduce<number>((acc: any, child: any) => {
				if (child instanceof HTMLElement) {
					return acc + child.getBoundingClientRect().width;
				  }
				  return acc;
		    }, 0);
		   this.setState({ isWidthReached: (childrenWidth > containerWidth) });
		}
	  }
	}

	setUlRef = (element: any) => {
		this.ulRef = element;
		if (this.ulRef) {
		  this.checkWidth();
		}
	};
	render() {
		const { isDeleteDialogOpen, isShareDialogOpen, selectedContents, selectedContentsAll,
			isDetailDrawerOpen, DetailDrawerContent,
			filterContent, showTooltipExpand, selectAllContent,
			currentPage, totalCount, expandedFilter, filteredQuestions,
			topSpacing, dropdownSelectedValue, unselectedContents, areGoalsSectionClicked,
			contentFilterData, visibleFilters, isRevert, isApply, isAddFilterOpen, bucketsToShow, selectedBucketType, academicYear, selectedAcademicYearList, academicYearList, isGoalsDrillerOpen, isSideFilterOpen,
			bucketWiseCount, validationDialogInfoType, isPublishDirectlyModalOpen, recentSuggestions, tagsPool, searchResults, seeAllTags, isSearchBoxClicked, isWidthReached
		} = this.state;
		const { classes, contentList, filterHeaderClassName, fromCourse, goals, fromTestPaper, isSelectAllRequired = true, contentCreateOption, isCreatedByMe, selectedContentType, contentStatusCode } = this.props;
		let searchTextRegex;
		const contentMenu = (filterContent && filterContent.contentMenu) || VALIDATION.CREATED_BY_ME;

		const contentListToShow = this.removeSelectedQuestionFromContent();
		const showInfoForResubmitted = contentListToShow.some(content => (content.status).toLocaleLowerCase() === FEEDBACK_VALIDATOR_ACTIONS.RE_SUBMITTED.toLocaleLowerCase());
		const notStudentUser = !getUserType(USER_TYPE.STUDENT);
		const isOnyQuestionSelected = this.checkOnlyQuestionSelected();
		return (
			<>
				<Grid id="sticky-header-filter" container className={classes.filterHeaderClassName}>
					<Grid item xs={12}>
						{this.props.contentMenuRequired && (<ContentMenu contentCreateOption={contentCreateOption} selectedcontentMenu={filterContent.contentMenu} contentMenuChanged={this.contentMenuChanged} isCreatedByMeEnabled={isCreatedByMe}
							bucketsToShow={bucketsToShow} selectedBucketType={selectedBucketType} changeBucketType={this.changeBucketType.bind(this)} fromTestPaper={fromTestPaper} handleGoalsDrillerToggle={this.handleGoalsDrillerToggle.bind(this)}
							academicYear={academicYear} academicYearList={academicYearList} selectedAcademicYearList={selectedAcademicYearList} handleAcademicYearChange={this.handleAcademicYearChange.bind(this)} handleFilterToggle={this.handleFilterToggle.bind(this)}
							filterContent={filterContent} onStartValidation={this.startNewValidation.bind(this)} handleQuestionStatusChange={this.handleQuestionStatusChange} bucketWiseCount={bucketWiseCount} isOnyQuestionSelected={isOnyQuestionSelected}
							handleValidationInfoDialogOpen={this.handleValidationInfoDialogOpen.bind(this)} />)}
					</Grid>
				</Grid>

				<CustomFilter handleFilterToggle={this.handleFilterToggle.bind(this)} isFilterOpen={isSideFilterOpen} filterData={filterContent.contentFilterData} handleFilterSelected={this.handleFilterSelected.bind(this)} fromTestPaper={fromTestPaper} contentMenuSelected={filterContent.contentMenu} isTeacher={this.isUserTeacher}/>
				<div className={cx(classes.browseByTopics, {[classes.visiblebrowseTopic]: isGoalsDrillerOpen})}>
				<GoalsDriller key={selectedBucketType === CONTENT_SECTION_KEYS.FTRE ? 0 : 1} handleGoalsSectionClick={(value: boolean) => this.handleGoalsSectionClick.bind(this, value)} goals={goals} fromCourse={fromCourse} goalsDriller={filterContent.goalsDriller} goaldsDrillerChanged={this.goaldsDrillerChanged} getTopSpacing={this.getTopSpacing} filterContent={filterContent} alwaysFetchCoursesInGoalDriller={this.props.alwaysFetchCoursesInGoalDriller} isConcept={this.props.isConcept} isCourse={this.props.isCourse} isChapter={this.props.isChapter} selectedBucketType={selectedBucketType} handleGoalsDrillerToggle={this.handleGoalsDrillerToggle.bind(this)} />
				</div>
				

				<Grid id="with-content-wrapper" container className={classes.relativeBox}>
					{/* <Grid style={{ position: 'sticky', width: '25%', top: '0px', 'align-self': 'flex-start' }} item xs={3} className={classes.leftSideBar}>
						{contentMenu !== VALIDATION.VALIDATION_REQUEST && notStudentUser && <GoalsDriller key={selectedBucketType} handleGoalsSectionClick={(value: boolean) => this.handleGoalsSectionClick.bind(this, value)} goals={goals} fromCourse={fromCourse} goalsDriller={filterContent.goalsDriller} goaldsDrillerChanged={this.goaldsDrillerChanged} getTopSpacing={this.getTopSpacing} filterContent={filterContent} alwaysFetchCoursesInGoalDriller={this.props.alwaysFetchCoursesInGoalDriller} isConcept={this.props.isConcept} isCourse={this.props.isCourse} isChapter={this.props.isChapter} selectedBucketType={selectedBucketType} />}

						{
							!fromTestPaper && (
								<>
									{this.renderFilters()}
									{!isAddFilterOpen && (
										<ContentFilter
											selectedContentType={selectedContentType}
											contentFilterData={filterContent.contentFilterData}
											contentLength={contentList.length}
											contentFilterDataChanged={this.contentFilterDataChanged}
											visibleFilters={visibleFilters}
											fromTestPaper={fromTestPaper}
											removeDisabilityFromCheckBox={this.props.removeDisabilityFromCheckBox}
											isRevert={isRevert}
											isApply={isApply}
											hideContent={true}
											selectedBucketType={selectedBucketType}
											topSpacing={topSpacing} />
									)}
								</>
							)
						}


						<Card className={cx({ [classes.fixedSection]: !areGoalsSectionClicked, [classes.fixedSectionScroll]: areGoalsSectionClicked }, (fromTestPaper ? classes.fromTestPaper : ""))}>
							<CardHeader
								action={
									<>
										<div className={classes.marginTop1x}>
											<IconButton className={cx(classes.expand, {
												[classes.expandOpen]: !expandedFilter,
											})}
												onClick={this.filterExpandClick}
												aria-expanded={expandedFilter}
												aria-label="show more"
												onMouseOver={this.handleHover.bind(this)}
												onMouseOut={this.handleHover.bind(this)}
											>
												<ExpandMoreIcon fontSize='small' height='1.5em' />
											</IconButton>
											<span className={classes.tooltipDetails}>
												{
													showTooltipExpand &&
													<>
														<CustomInfoIcon
															isInfoIcon={false}
															isCenterArrow={false}
															isRightArrow={showTooltipExpand}
															details="Click to expand"
															toolTipDirection="right" />
													</>
												}

											</span>
										</div>
									</>
								}
								title={
									<Typography component="h6" variant="body1">
										Applied Filters
										<span className={classes.infoIcon}>
											<CustomInfoIcon
												infoDialogContentType="filters"
												isInfoIcon={true}
												isRightArrow={false}
												isCenterArrow={true}
												knowMoreAbout={true}
												componentName="filter"
												dialogTitle="Filter"
												imageURL="/assets/svg/infoIcon/myLibrary/filter.svg"
												dialogPara="Apart from the Goal filters, you can add more filters like Status, Content type etc related to the content by clicking on Add another filter."
												details="Click to know more"
												toolTipDirection="top" />
										</span>
									</Typography>}
								className={classes.cardHeader}
							/>
							<Collapse in={expandedFilter} timeout="auto" unmountOnExit>
								<CardContent className={classes.scrollBarX}>
									<PerfectScrollbar>
										{this.filterChip()}
									</PerfectScrollbar>
								</CardContent>
							</Collapse>
						</Card>
						<Grid id="add-filter-button" item xs={12} className={classes.addFilterWrapper}>
							<Button className={classes.borderBlue} onClick={() => this.setState({ isAddFilterOpen: !this.state.isAddFilterOpen })}>Add another filter</Button>
						</Grid>
					</Grid> */}
					<Modal
						disablePortal
						disableEnforceFocus
						disableAutoFocus
						open={this.state.isAddFilterOpen}
						onBackdropClick={(e: React.MouseEvent<HTMLButtonElement>) => this.handleAddFilterOpen(e)}
						onClose={(e: React.MouseEvent<HTMLButtonElement>) => this.handleAddFilterClose(e)}
						aria-labelledby="server-modal-title"
						aria-describedby="server-modal-description"
						className={classes.modal}>
						<div className={classes.filterCard}>
							<Card className={classes.root}>
								<CardHeader className={[classes.modalHeader, classes.borderBottom].join(' ')}
									action={
										<IconButton aria-label="settings" onClick={(e: React.MouseEvent<HTMLButtonElement>) => this.handleAddFilterClose(e)}>
											<CloseIcon fontSize="large" />
										</IconButton>
									}
									title="Filter"
								/>
								{/* <CardContent className={[classes.cardContent, classes.padding0x, classes.filterListBlock].join(' ')}>
									<div className={classes.modalHeader}>
										<Typography variant="h6" component="body1" className={classes.greyColor} align="left">Applied Filter</Typography>
										<div className={classes.modalFilterChip}>{this.filterChip(true)}</div>
									</div>
									<Divider /> */}
								{/* </CardContent> */}
							</Card>
						</div>
					</Modal>



					<Grid item xs={12} className={classes.marginMDBgWhite} id="content-list-wrapper">
						<Grid id="content-list-container"
							container alignItems="center" className={[classes.paddingLeft, classes.paddingRight].join(' ')}>
							<div className={classes.fixTopSearch}>
								<div className={classes.leftSearch}>
									<Grid className={classes.paper}>
										<Grid className={classes.searchBox}>
											{contentMenu !== VALIDATION.VALIDATION_REQUEST && isSelectAllRequired &&
												<>
													<Checkbox
														onChange={this.selectPageItem}
														checked={selectedContentsAll || selectAllContent}
														id={'all-check-box'}
														classes={{
															root: classes.SelectCheckbox,
															checked: classes.SelectcheckedCheckbox,
															colorPrimary: classes.primaryColor
														}}

														color="primary" />
													<span className={cx(classes.lightGrey, classes.selectAllText)}>Select All</span>
												</>}
											{this.multipleSelectOption()}
											{
												this.getURL.includes("user-management") == true ?
													<span style={{ position: 'relative', display: 'inline-block', top: '-5px' }}>
														<select onChange={this.changeLimit.bind(this)} style={{ height: '34px', border: 'none', marginRight: '10px', borderRadius: '4px' }}
															defaultValue="thisPages">
															<option value="" defaultValue="">Select Options</option>
															<option value="thisPages">Current Page</option>
															<option value="allPages">All Pages</option>
														</select>
													</span> : <></>
											}

											<ContentSearch  clearSuggestions={this.clearSuggestions} searchText={filterContent.searchText} searchTextChanged={this.searchTextChanged} currentBucket={selectedBucketType} getRecentSuggestions={this.getRecentSuggestions}
															recentSuggestions={recentSuggestions} addSuggestionToPool={this.addSuggestionsToTagsPool}
															searchResults={searchResults} incrementTagClickedCount={this.increaseTagClickedCount}
															fetchSearchDataAccordingToSelectedTag={(data: any) => this.filterSearchAccordingToTags(data)}
															clearSearchData={this.clearSearchResults} isSearchBoxClicked={() => {this.setState({isSearchBoxClicked: true})}}		
											className="heightSet" />
										</Grid>
									</Grid>
								</div>
								<div className={classes.rightPaging}>
									<Grid className={classes.textRight}>
										{VALIDATION.TABS.includes(contentMenu) && <span onClick={() => this.setState({ legendDialogVisible: true, validationDialogInfoType: VALIDATION_DIALOG_INFO_TYPES.LEGEND })} className={classes.legendText}>View Legends</span>}
										<MyPATDialog
											dialogOpen={this.state.legendDialogVisible}
											isPerfectScrollbar={false}
											customButtonVariant="withoutBorderCloseIcon"
											onDialogClose={() => this.setState({ legendDialogVisible: false })}
											otherDialogProps={{
												fullWidth: true,
												maxWidth: 'sm',
												scroll: 'body',
											}}
											dialogHeading={
												<>
													<span className={classes.legendModalTitle}>Information</span>
												</>
											}
											customDialogActions={
												<>
													<Grid container justify="center" className={classes.legendDialogAction}>
														<Button variant="contained" color="primary" 
															onClick={() => this.setState({ legendDialogVisible: false })}>Okay</Button>
													</Grid>
												</>
											}
										>
											<div className={classes.validationInfoTabs}>
												<ul>
													<li onClick={() => this.setState({ validationDialogInfoType: VALIDATION_DIALOG_INFO_TYPES.LEGEND })} className={cx({ 'active': validationDialogInfoType === VALIDATION_DIALOG_INFO_TYPES.LEGEND })}>Legends</li>
													<li onClick={() => this.setState({ validationDialogInfoType: VALIDATION_DIALOG_INFO_TYPES.OTHER })} className={cx({ 'active': validationDialogInfoType === VALIDATION_DIALOG_INFO_TYPES.OTHER })}>Other Information</li>
												</ul>
											</div>
											<Typography variant="body1">
												<ul className={classes.legendListing}>
													{getPropertyValue(VALIDATION_DIALOG_DATA, `${contentMenu}.${validationDialogInfoType}`, []).map((data: any, index: number) => (
														<li className={cx('listItem', {'other-info': validationDialogInfoType === VALIDATION_DIALOG_INFO_TYPES.OTHER})} key={index}>
														<div className={cx('col-left', data.class)} >
															<p>{data.title}</p>
														</div>
														<div className='col-right'>
															<p>{data.description}</p>
														</div>
													</li>
													))
													}
												</ul>
											</Typography>
										</MyPATDialog>
										<ContentPagination classes={{ root: classes.inlineBlock }} page={currentPage} count={totalCount} rowsPerPage={fromTestPaper ? this.getLimitForPagination() : 20} onChangePage={this.nextPage} />
										{/* <ACL
												layerType={['CONTENT']}
												accessType={['EDIT', 'SHARE', 'DELETE']}
												className={classes.tooltip}
											>
												<ContentMoreMenu
													attachedcomponent="Click to share or delete any content"
													classes={{ root: classes.inlineBlock }}
													clicked={this.moreMenuClicked}
													shareButtonDisabled={this.state.filterContent.contentMenu === SHAREDWITHMEKAY}
												/>
											</ACL> */}
										<ContentDeleteConfirm isDeleteDialogOpen={isDeleteDialogOpen} contentList={selectedContents} onDeleteConfirmed={this.onDeleteConfirmed} />
										<ContentShareModal
											filters={filterContent}
											selectAllContent={selectAllContent}
											UnSelectedIDs={unselectedContents}
											contentList={selectedContents}
											totalCount={totalCount}
											dropdownSelectedValue={dropdownSelectedValue}
											isShareDialogOpen={isShareDialogOpen}
											onShared={this.onShared}
										/>
									</Grid>
								</div>
							</div>
							{this.isUserTeacher && notStudentUser && !fromTestPaper && (contentMenu == VALIDATION.VALIDATION_REQUEST) && showInfoForResubmitted &&
								<div className={classes.highlightedContent}>
									<img src="/assets/svg/contentValidation/validation-sign.svg" alt="Mark" />
									<p>The question highlighted with this mark requires your immediate action. Failure to take action within 7 days will result in re-assignment of these questions and loss of all validation points gained for such questions.</p>
								</div>
							}
							{
								this.state.selectedContents.length > 0 /* || (selectAllContent || selectedContentsAll) && this.state.selectedContents.length > 0) */
								&& (
									<Grid item xs={12}>
										<Grid container justify="space-between" alignItems="center">
											<Grid item>
												<Grid className={classes.noSelectedText}>
													<span className={classes.lightGrey}>
														<strong>
															<span>{this.state.selectedContents.length}</span>&nbsp;<span>Selected</span>
														</strong>
													</span>
												</Grid>
											</Grid>
											{!this.props.fromTestPaper && this.props.type !== 'studymaterial' && (
												<Grid item>
													<Grid className={classes.dataManipulateIcons}>
														{this.isUserTeacher && notStudentUser && filterContent.contentMenu === VALIDATION.CREATED_BY_ME && selectedContents.every(content => (content.validationStatus === FEEDBACK_VALIDATOR_ACTIONS.IN_REVIEW) && !content.contentId.includes(CONTENT_STATES.DRAFT)) &&
															<Tooltip title="Publish Before Validation">
																<span
																	className='publishDirectly'
																	onClick={() => this.setState({ isPublishDirectlyModalOpen: true })}>
																	<img alt="publish" src='/assets/svg/myLibrary/publish-directly.svg' />
																</span>
															</Tooltip>
														}
														{/* {notStudentUser && <span
															className={!ACLService.checkModulePermission("share", "allow") ? classes.disable : ""}
															onClick={() => this.moreMenuClicked('Share')}>
															<img alt="share" src='/assets/svg/myLibrary/share.svg' />
														</span>
														} */}
														<span
															className={this.checkDeletePermission() ? classes.disable : ""}
															onClick={() => this.moreMenuClicked('Delete')}>
															<img alt="delete" src='/assets/svg/myLibrary/delete.svg' />
														</span>
													</Grid>
												</Grid>
											)}
										</Grid>
									</Grid>
								)}

							{/* Global Search Tabs */}
							{ ((tagsPool || []).length) ?
								(<div className={`${classes.globalSearchTabsSection} ${seeAllTags ? 'see-all' : ''}`}>
									<div className='search-for-text'>Search for</div>
									<ul ref={this.setUlRef} className='tab-listing'>
										{ tagsPool.map((tags: any, index: number) => {
											return (
												<li key={tags.tagId}>
												<Tooltip title={tags.tagDisplayName} placement="bottom" classes={{ tooltip: classes.customTooltip }}>
													<Button>
														<h6 className={(tags.tagDisplayName.length > 20) ? 'hiddenContent' : ''}>{tags.tagDisplayName}</h6><em onClick={(ev) => {ev.nativeEvent.stopImmediatePropagation();this.removeTagFromTagPool(index)}}></em>
													</Button>
												</Tooltip>
											</li>
											)
										})}
									</ul>
									<div className='clear-text'>
										<span onClick={() => this.setState({clearTagModal: true})} className='heading'>Clear All</span>
										{ isWidthReached && <span onClick={() => this.setState({seeAllTags: !seeAllTags})} className='arrow'></span> }
									</div>
								</div>) : <></>
							}

							<Grid item xs={12} className={classes.cardsContainer}>
								{
									!_.isEmpty(contentList) ?
										contentListToShow.map((content: ContentData, index: number) => {
											searchTextRegex = new RegExp(`(${filterContent.searchText})`, "ig");
											if (filterContent.searchText) {
												content.title = content.title ? content.title.replace(searchTextRegex, `<mark>$1</mark>`) : ''
											}

											return (
												<ContentCard
													key={content.content_Id + index || index}
													index={index}
													content={content}
													setContentSelected={this.setContentSelected}
													isInSelectedContent={this.isInSelectedContent}
													isAllSelectedContent={selectedContentsAll || selectAllContent}
													isInDisableContent={this.isInDisableContent}
													onViewDetailsClick={this.handleDetailDrawerOpen.bind(this)}
													onFavouriteClick={this.markAsFavourite}
													fromCourse={fromCourse}
													fromTestPaper={fromTestPaper}
													hideAuthor={VALIDATION.TABS.includes(contentMenu)}
													hideSelectOption={contentMenu == VALIDATION.VALIDATION_REQUEST}
												/>

											)
										}) : <NoFilteredContent isRestrictedAccess={contentStatusCode === STATUS_CODES.FORBIDDEN_ACCESS} />
								}
							</Grid>
						</Grid>
					</Grid>
				</Grid>
				<ContentDetailsDrawer
					onDetailDrawerClose={this.handleDetailDrawerClose.bind(this)}
					isDetailsDrawerOpen={isDetailDrawerOpen}
					content={DetailDrawerContent}
				/>
				<PublishContentDirecltyModal isModalOpen={isPublishDirectlyModalOpen} onModalClose={this.onPublishDirecltyModalClose.bind(this)} onDeclarationAccept={this.publishInReviewQuestions.bind(this)} fromLibrary={true} selectedQuestionsCount={selectedContents.length}/>
				<Modal
						disablePortal
						disableEnforceFocus
						disableAutoFocus
						disableBackdropClick
						open={this.state.clearTagModal}
						className={classes.modal}>
						<div className={classes.clearTagsModal}>
							<div className='modal-header'>Clear Tags</div>
							<div className="modal-content">
								<p className="modal-para">
									Are you sure you want to clear all saved search tags?
								</p>
							</div>
							<div className='modal-footer'>
								<button
									className="btn-border"
									onClick={() => {
										this.setState({ clearTagModal: false})
									}}                
								>
								No
								</button>
								<button
									className="btn-primary"
									onClick={this.clearAllTags}
								>
								Yes
								</button>
							</div>
						</div>
					</Modal>
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
	userId: _.get(state, "loginData.userData.authenticatedUser._id", "a"),
	contentList: _.get(state, 'mylibraryData.content.list', []),
	contentStatusCode: _.get(state, 'mylibraryData.content.statusCode', []),

	// from testpaper
	contentType: _.get(state, 'mylibraryData.contentType', {}),
	contentSubtype: _.get(state, 'mylibraryData.contentSubtype', {}),
	contentStatus: _.get(state, 'mylibraryData.contentStatus', {}),
	contentTags: _.get(state, 'mylibraryData.contentTags', []),
	courses: _.get(state, 'mylibraryData.courses', []),
	filterBy: _.get(state, 'mylibraryData.filterByUser', []),
	classesData: _.get(state, 'mylibraryData.classes', {}),
	userData: state.loginData.userData,
	loggedInUserData:
		state.loginData.userData &&
		state.loginData.userData.loggedInUserData,
	showLicenseExpiredDialog:
		state.loginData.userData &&
		state.loginData.userData.showLicenseExpiredDialog,
	isPostExpiryDays:
		state.loginData.userData &&
		state.loginData.userData.isPostExpiryDays,
	isQuestionSubtypeLoaded: ((state.mylibraryData || {}).contentSubtype || {}).isQuestionSubtypeLoaded,
	isStudyMaterialSubtypeLoaded: ((state.mylibraryData || {}).contentSubtype || {}).isStudyMaterialSubtypeLoaded, 

});

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
	{
		contentActionList: contentActions.list,
		clearContentListData: contentActions.clearContentListData,

		// from testpaper
		contentStatusList: contentStatusActions.list,
		contentTypeList: contentTypeActions.list,
		contentSubtypeList: contentSubtypeActions.list,
		contentSubtypeByContentTypeCode: contentSubtypeActions.contentSubtypeByContentTypeCode,
		contentTagsList: contentTagsActions.contentTagsList,
		coursesList: coursesActions.coursesList,
		userFilterList: contentActions.userList,
		classesList,
		toggleLicenseExpiredDialog,
		showMsg: showMsg,
		contentValidationStatusList: contentStatusActions.validationList
	},
	dispatch
);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(WithContent));